import React, { Component } from "react";
import { Row, Col, Card, CardBody } from "reactstrap";
import { connect } from "react-redux";
import ContentWrapper from "../../../template/Layout/ContentWrapper";

import Loader from "../../../Global/Loader";

import Axios from "axios";
import { Services } from "../Services";
import { isMovil } from "../../../utils/device";
import "./styles.scss";
import MultiSelectPaginate from "../../../Global/MultiSelect";
import { loadOptions, getFilterData } from "./loadOptions";
import { filter, forEach } from "lodash";
import { FullLoader } from "../components/Loader";
import Table from "../../Components/TableCustom";
import { Modal, Space, Button } from "antd";
import DataTable from "../../Components/DataTable";
import { Popup } from "semantic-ui-react";
import { Link } from "react-router-dom";
import { Icon } from "semantic-ui-react";
import { Search } from "semantic-ui-react";
import CardsTotals from "../components/CardTotals";
import { Divider } from "antd";
import { saveAs } from "file-saver";
import moment from "moment";
import HorizontalTimeline from "../components/TimeLine";

/*=============================================
=            BoardImpo Component              =
=============================================*/

const { confirm } = Modal;
class BoardImpo extends Component {
  constructor(props) {
    super(props);
    this.state = {
      rolId: props._rolId,
      customWidth: window.innerWidth,
      fullLoader: false,
      loadingTrends: false,
      value: [],
      viewDetails: false,
      pages: 1,
      search: "",
      searchInput: '',
      loading: false,
      loadingDetails: false,
      dashboardConfigId: 1,
      filters: [
        {
          col: "col-md-3 col-lg-3 col-sm-12",
          title: "Pedido",
        },
        {
          col: "col-md-3 col-lg-3 col-sm-12",
          title: "Proveedor",
        },
        {
          col: "col-md-3 col-lg-3 col-sm-12",
          title: "Referencia",
        },
        {
          col: "col-md-3 col-lg-3 col-sm-12",
          title: "Factura",
        },
        {
          col: "col-md-3 col-lg-3 col-sm-12",
          title: "Doc. Trans.",
        },
        {
          col: "col-md-3 col-lg-3 col-sm-12",
          title: "País de origen",
        },
        {
          col: "col-md-3 col-lg-3 col-sm-12",
          title: "DO",
        },
        {
          col: "col-md-3 col-lg-3 col-sm-12",
          title: "Aduana",
        },
      ],
      columnsProcess: [
        // {
        //   Id: 1,
        //   Name: "Embarques con DIM anticipadas SIN aceptar",
        //   Total: 0,
        //   EnRiesgo: 0,
        //   TipoDias: "Días calendario",
        //   Desviados: 0,
        // },
        {
          label: "Nombre y orden botones",
          dataIndex: "Name",
          key: "Name",
          backgroundColor: "#D8D8D8",
          textColor: "#000",
          textAlign: "left",
          custom: (value) => {
            return (
              <span
                style={{
                  color: "#003F70",
                  fontWeight: "bold",
                  textAlign: "left",
                  textColor: "#000",
                  cursor: "pointer",
                }}
                onClick={() => {
                  this.handleClickDetails(value.Id, value.Name);
                }}
              >
                {value.Name}
              </span>
            );
          },
        },
        // {
        //   label: "Nombre y orden botones",
        //   key: "nombre",
        //   backgroundColor: "#D8D8D8",
        //   textColor: "#000",
        //   sizeColumn: "150px",
        //   textAlign: "left",
        // },
        {
          label: "Total",
          key: "Total",
          backgroundColor: "#D8D8D8",
          textColor: "#000",
          sizeColumn: "6px",
        },
        {
          label: "Desviados",
          key: "Desviados",
          backgroundColor: "#D51C29",
          textColor: "#000",
          sizeColumn: "6px",
        },
        {
          label: "En riesgo",
          key: "EnRiesgo",
          backgroundColor: "#FFFF1D",
          textColor: "#000",
          sizeColumn: "6px",
        },
        // {
        //   label: "Tipo de días calculo",
        //   key: "TipoDias",
        //   backgroundColor: "#D8D8D8",
        //   textColor: "#000",
        // },
      ],
      processData: [
        // {
        //   Id: 1,
        //   Name: "Embarques con DIM anticipadas SIN aceptar",
        //   Total: 0,
        //   EnRiesgo: 0,
        //   TipoDias: "Días calendario",
        //   Desviados: 0,
        // },
        {
          Name: "Embarques con DIM anticipadas SIN aceptar",
          Total: "0",
          Desviados: "0",
          EnRiesgo: "0",
          TipoDias: "Días calendario",
        },
        {
          Name: "Embarques como entrega directa llegados SIN levante",
          Total: "0",
          Desviados: "0",
          EnRiesgo: "0",
          TipoDias: "Días hábiles",
        },
        {
          Name: "DO's con DIM aceptadas SIN autoadhesivo o pago",
          Total: "0",
          Desviados: "0",
          EnRiesgo: "0",
          TipoDias: "Días hábiles",
        },
        {
          Name: "Mercancia en deposito público SIN levante",
          Total: "0",
          Desviados: "0",
          EnRiesgo: "0",
          TipoDias: "Días calendario",
        },
        {
          Name: "Operaciones de DTA",
          Total: "0",
          Desviados: "0",
          EnRiesgo: "0",
          TipoDias: "Días calendario",
        },
      ],
      pendingData: [
        {
          Name: "Embarques SIN ETA",
          Total: "0",
          Desviados: "0",
          EnRiesgo: "0",
          TipoDias: "Días calendario",
        },
        {
          Name: "Embarques SIN documentos de transporte",
          Total: "0",
          Desviados: "0",
          EnRiesgo: "0",
          TipoDias: "Días hábiles",
        },
        {
          Name: "Otros documentos soporte pendientes",
          Total: "0",
          Desviados: "0",
          EnRiesgo: "0",
          TipoDias: "Días hábiles",
        },
        {
          Name: "DO's SIN entrega al transporte",
          Total: "0",
          Desviados: "0",
          EnRiesgo: "0",
          TipoDias: "Días hábiles",
        },
        {
          Name: "DO´s SIN despacho",
          Total: "0",
          Desviados: "0",
          EnRiesgo: "0",
          TipoDias: "Días hábiles",
        },
      ],
      billingData: [
        {
          Name: "Embarques sin anticipo",
          Total: "0",
          Desviados: "0",
          EnRiesgo: "0",
          TipoDias: "Días hábiles",
        },
        {
          Name: "Embarques por facturar",
          Total: "0",
          Desviados: "0",
          EnRiesgo: "0",
          TipoDias: "Días hábiles",
        },
        {
          Name: "Proformas por autorizar",
          Total: "0",
          Desviados: "0",
          EnRiesgo: "0",
          TipoDias: "Días hábiles",
        },
        {
          Name: "Estado cartera",
          Total: "0",
          Desviados: "0",
          EnRiesgo: "0",
          TipoDias: "Días calendario",
        },
      ],
      documentsData: [
        {
          Name: "Vigencia de registros o anexos",
          Total: "0",
          Desviados: "0",
          EnRiesgo: "0",
          TipoDias: "Días calendario",
        },
      ],
      ImpoDetailsTables: {
        1: [
          {
            label: "DO",
            key: "do",
            minWidth: 150,
            maxWidth: 170,
            limitString: 20,
            className: "col-md-3 col-lg-2 col-sm-6",
            custom: (value) => ({
              content:
                value.do.length > 20 ? (
                  <Popup
                    content={value.do}
                    key={value.do}
                    popperModifiers={{
                      preventOverflow: {
                        boundariesElement: "offsetParent",
                      },
                    }}
                    positionFixed={true}
                    position="top center"
                    size="mini"
                    trigger={
                      <Link
                        style={{ color: "#003F70", fontWeight: "bold" }}
                        to={`/custom-detail-view/` + value.id}
                      >
                        {`${value.do.substring(0, 17)}...`}
                      </Link>
                    }
                  />
                ) : (
                  <Link
                    style={{ color: "#003F70", fontWeight: "bold" }}
                    to={`/custom-detail-view/` + value.id}
                  >
                    {value.do}
                  </Link>
                ),
            }),
          },
          {
            label: "Pedido",
            key: "pedido",
            minWidth: 150,
            maxWidth: 170,
            limitString: 20,
            className: "col-md-3 col-lg-2 col-sm-6",
            custom: (value) => ({
              content:
                value?.pedido?.length > 20 ? (
                  <Popup
                    content={value?.pedido}
                    key={value?.pedido}
                    popperModifiers={{
                      preventOverflow: {
                        boundariesElement: "offsetParent",
                      },
                    }}
                    positionFixed={true}
                    position="top center"
                    size="mini"
                    trigger={
                      <span>{`${value?.pedido.substring(0, 17)}...`}</span>
                    }
                  />
                ) : (
                  <span>{value?.pedido}</span>
                ),
            }),
          },
          {
            label: "Serv. al cliente (CS)",
            key: "servCliente",
            minWidth: 150,
            maxWidth: 150,
            className: "col-md-3 col-lg-1 col-sm-6",
          },
          {
            label: "Cliente",
            key: "cliente",
            minWidth: 150,
            maxWidth: 150,
            className: "col-md-3 col-lg-1 col-sm-6",
          },
          {
            label: "Aduana",
            key: "aduana",
            minWidth: 150,
            maxWidth: 150,
            className: "col-md-3 col-lg-1 col-sm-6",
          },
          {
            label: "Medio transporte internacional",
            key: "transportInternacional",
            minWidth: 150,
            maxWidth: 150,
            className: "col-md-3 col-lg-1 col-sm-6",
          },
          {
            label: "Transportadora / ACI",
            key: "transportadora",
            minWidth: 150,
            maxWidth: 150,
            className: "col-md-3 col-lg-1 col-sm-6",
          },
          {
            label: "Proveedor",
            key: "proveedor",
            minWidth: 150,
            maxWidth: 150,
            className: "col-md-3 col-lg-1 col-sm-6",
          },
          {
            label: "Doc transporte",
            key: "docTransporte",
            minWidth: 150,
            maxWidth: 150,
            className: "col-md-3 col-lg-1 col-sm-6",
          },
          {
            label: "No. de factura(s)",
            key: "noFactura",
            minWidth: 150,
            maxWidth: 170,
            limitString: 20,
            className: "col-md-3 col-lg-2 col-sm-6",
            custom: (value) => ({
              content:
                value?.noFactura?.length > 20 ? (
                  <Popup
                    content={value?.noFactura}
                    key={value?.noFactura}
                    popperModifiers={{
                      preventOverflow: {
                        boundariesElement: "offsetParent",
                      },
                    }}
                    positionFixed={true}
                    position="top center"
                    size="mini"
                    trigger={
                      <span>{`${value?.noFactura.substring(0, 17)}...`}</span>
                    }
                  />
                ) : (
                  <span>{value?.noFactura}</span>
                ),
            }),
          },
          {
            label: "ETA",
            key: "eta",
            minWidth: 150,
            maxWidth: 150,
            className: "col-md-3 col-lg-1 col-sm-6",
          },
          {
            label: "Tipo de trayecto",
            key: "tipotrayecto",
            minWidth: 150,
            maxWidth: 150,
            className: "col-md-3 col-lg-1 col-sm-6",
          },
          {
            label: "Fecha doc transporte",
            key: "fechaDocTransporte",
            minWidth: 150,
            maxWidth: 150,
            className: "col-md-3 col-lg-1 col-sm-6",
          },
          {
            label: "Fecha factura comercial",
            key: "fechaFacturaComercial",
            minWidth: 150,
            maxWidth: 150,
            className: "col-md-3 col-lg-1 col-sm-6",
          },
          {
            label: "Fecha certificado origen",
            key: "fechaCertificadoOrigen",
            minWidth: 150,
            maxWidth: 150,
            className: "col-md-3 col-lg-1 col-sm-6",
          },
          {
            label: "Fecha consulta inventario",
            key: "fechaConsultaInventario",
            minWidth: 150,
            maxWidth: 150,
            className: "col-md-3 col-lg-1 col-sm-6",
          },
          {
            label: "Fecha certificado ICA",
            key: "fechaCertificadoIca",
            minWidth: 150,
            maxWidth: 150,
            className: "col-md-3 col-lg-1 col-sm-6",
          },
          {
            label: "Fecha certificado INVIMA",
            key: "fechaCertificadoInvima",
            minWidth: 150,
            maxWidth: 150,
            className: "col-md-3 col-lg-1 col-sm-6",
          },
          {
            label: "Registro de importación",
            key: "registroDeImportacion",
            minWidth: 150,
            maxWidth: 150,
            className: "col-md-3 col-lg-1 col-sm-6",
          },
          {
            label: "Fecha Poliza de Seguro",
            key: "polizaSeguroFechaLC",
            minWidth: 150,
            maxWidth: 150,
            className: "col-md-3 col-lg-1 col-sm-6",
          },
          {
            label: "Fecha máxima aceptación",
            key: "fechaMaximaAceptacion",
            minWidth: 150,
            maxWidth: 150,
            className: "col-md-3 col-lg-1 col-sm-6",
            className: "col-md-3 col-lg-2 col-sm-6",
            custom: (value) => {
              return {
                backgroundColor: value.hex,
                content: <span>{value["fechaMaximaAceptacion"]}</span>,
              };
            },
          },
        ],
        2: [
          {
            label: "DO",
            key: "do",
            minWidth: 150,
            maxWidth: 170,
            limitString: 20,
            className: "col-md-3 col-lg-2 col-sm-6",
            custom: (value) => ({
              content:
                value.do.length > 20 ? (
                  <Popup
                    content={value.do}
                    key={value.do}
                    popperModifiers={{
                      preventOverflow: {
                        boundariesElement: "offsetParent",
                      },
                    }}
                    positionFixed={true}
                    position="top center"
                    size="mini"
                    trigger={
                      <Link
                        style={{ color: "#003F70", fontWeight: "bold" }}
                        to={`/custom-detail-view/` + value.id}
                      >
                        {`${value.do.substring(0, 17)}...`}
                      </Link>
                    }
                  />
                ) : (
                  <Link
                    style={{ color: "#003F70", fontWeight: "bold" }}
                    to={`/custom-detail-view/` + value.id}
                  >
                    {value.do}
                  </Link>
                ),
            }),
          },
          {
            label: "Pedido",
            key: "pedido",
            minWidth: 150,
            maxWidth: 170,
            limitString: 20,
            className: "col-md-3 col-lg-2 col-sm-6",
            custom: (value) => ({
              content:
                value?.pedido?.length > 20 ? (
                  <Popup
                    content={value?.pedido}
                    key={value?.pedido}
                    popperModifiers={{
                      preventOverflow: {
                        boundariesElement: "offsetParent",
                      },
                    }}
                    positionFixed={true}
                    position="top center"
                    size="mini"
                    trigger={
                      <span>{`${value?.pedido.substring(0, 17)}...`}</span>
                    }
                  />
                ) : (
                  <span>{value?.pedido}</span>
                ),
            }),
          },
          {
            label: "Serv. al cliente (CS)",
            key: "servCliente",
            minWidth: 150,
            maxWidth: 150,
            className: "col-md-3 col-lg-1 col-sm-6",
          },
          {
            label: "Cliente",
            key: "cliente",
            minWidth: 150,
            maxWidth: 150,
            className: "col-md-3 col-lg-1 col-sm-6",
          },
          {
            label: "Aduana",
            key: "aduana",
            minWidth: 150,
            maxWidth: 150,
            className: "col-md-3 col-lg-1 col-sm-6",
          },
          {
            label: "Medio transporte internacional",
            key: "transportInternacional",
            minWidth: 150,
            maxWidth: 150,
            className: "col-md-3 col-lg-1 col-sm-6",
          },
          {
            label: "Doc transporte",
            key: "docTransporte",
            minWidth: 150,
            maxWidth: 150,
            className: "col-md-3 col-lg-1 col-sm-6",
          },
          {
            label: "Proveedor",
            key: "proveedor",
            minWidth: 150,
            maxWidth: 150,
            className: "col-md-3 col-lg-1 col-sm-6",
          },
          {
            label: "No. de factura(s)",
            key: "noFactura",
            minWidth: 150,
            maxWidth: 170,
            limitString: 20,
            className: "col-md-3 col-lg-2 col-sm-6",
            custom: (value) => ({
              content:
                value?.noFactura?.length > 20 ? (
                  <Popup
                    content={value?.noFactura}
                    key={value?.noFactura}
                    popperModifiers={{
                      preventOverflow: {
                        boundariesElement: "offsetParent",
                      },
                    }}
                    positionFixed={true}
                    position="top center"
                    size="mini"
                    trigger={
                      <span>{`${value?.noFactura.substring(0, 17)}...`}</span>
                    }
                  />
                ) : (
                  <span>{value?.noFactura}</span>
                ),
            }),
          },
          {
            label: "Fecha llegada M/CIA",
            key: "fechaLlegadaMcia",
            minWidth: 150,
            maxWidth: 150,
            className: "col-md-3 col-lg-1 col-sm-6",
          },
          {
            label: "Fecha Doc. completos",
            key: "fechaDocCompletos",
            minWidth: 150,
            maxWidth: 150,
            className: "col-md-3 col-lg-1 col-sm-6",
          },
          {
            label: "Fecha de fin descargue M/CIA",
            key: "fechaFinDescargueMcia",
            minWidth: 150,
            maxWidth: 150,
            className: "col-md-3 col-lg-1 col-sm-6",
          },
          {
            label: "Cantidad ítems",
            key: "cantidadItems",
            minWidth: 150,
            maxWidth: 150,
            className: "col-md-3 col-lg-1 col-sm-6",
          },
          {
            label: "Fecha de pago o sticker",
            key: "fechaPagoSticker",
            minWidth: 150,
            maxWidth: 150,
            className: "col-md-3 col-lg-1 col-sm-6",
          },
          {
            label: "Cantidad DIM",
            key: "cantidadDim",
            minWidth: 150,
            maxWidth: 150,
            className: "col-md-3 col-lg-1 col-sm-6",
          },
          {
            label: "Fecha doc transporte",
            key: "fechaDocTransporte",
            minWidth: 150,
            maxWidth: 150,
            className: "col-md-3 col-lg-1 col-sm-6",
          },
          {
            label: "Fecha factura comercial",
            key: "fechaFacturaComercial",
            minWidth: 150,
            maxWidth: 150,
            className: "col-md-3 col-lg-1 col-sm-6",
          },
          {
            label: "Fecha certificado origen",
            key: "fechaCertificadoOrigen",
            minWidth: 150,
            maxWidth: 150,
            className: "col-md-3 col-lg-1 col-sm-6",
          },
          {
            label: "Fecha consulta inventario",
            key: "fechaConsultaInventario",
            minWidth: 150,
            maxWidth: 150,
            className: "col-md-3 col-lg-1 col-sm-6",
          },
          {
            label: "Fecha certificado ICA",
            key: "fechaCertificadoICA",
            minWidth: 150,
            maxWidth: 150,
            className: "col-md-3 col-lg-1 col-sm-6",
          },
          {
            label: "Fecha certificado INVIMA",
            key: "fechaCertificadoINVIMA",
            minWidth: 150,
            maxWidth: 150,
            className: "col-md-3 col-lg-1 col-sm-6",
          },
          {
            label: "Registro de importación",
            key: "registroImportacionFechaLC",
            minWidth: 150,
            maxWidth: 150,
            className: "col-md-3 col-lg-1 col-sm-6",
          },
          {
            label: "Fecha máxima levante",
            key: "fechaMaximaLevante",
            minWidth: 150,
            maxWidth: 150,
            className: "col-md-3 col-lg-1 col-sm-6",
            className: "col-md-3 col-lg-2 col-sm-6",
            custom: (value) => {
              return {
                backgroundColor: value.hex,
                content: <span>{value["fechaMaximaLevante"]}</span>,
              };
            },
          },
        ],
        4: [
          {
            label: "DO",
            key: "do",
            minWidth: 150,
            maxWidth: 170,
            limitString: 20,
            className: "col-md-3 col-lg-2 col-sm-6",
            custom: (value) => ({
              content:
                value.do.length > 20 ? (
                  <Popup
                    content={value.do}
                    key={value.do}
                    popperModifiers={{
                      preventOverflow: {
                        boundariesElement: "offsetParent",
                      },
                    }}
                    positionFixed={true}
                    position="top center"
                    size="mini"
                    trigger={
                      <Link
                        style={{ color: "#003F70", fontWeight: "bold" }}
                        to={`/custom-detail-view/` + value.id}
                      >
                        {`${value.do.substring(0, 17)}...`}
                      </Link>
                    }
                  />
                ) : (
                  <Link
                    style={{ color: "#003F70", fontWeight: "bold" }}
                    to={`/custom-detail-view/` + value.id}
                  >
                    {value.do}
                  </Link>
                ),
            }),
          },
          {
            label: "Pedido",
            key: "pedido",
            minWidth: 150,
            maxWidth: 170,
            limitString: 20,
            className: "col-md-3 col-lg-2 col-sm-6",
            custom: (value) => ({
              content:
                value?.pedido?.length > 20 ? (
                  <Popup
                    content={value?.pedido}
                    key={value?.pedido}
                    popperModifiers={{
                      preventOverflow: {
                        boundariesElement: "offsetParent",
                      },
                    }}
                    positionFixed={true}
                    position="top center"
                    size="mini"
                    trigger={
                      <span>{`${value?.pedido.substring(0, 17)}...`}</span>
                    }
                  />
                ) : (
                  <span>{value?.pedido}</span>
                ),
            }),
          },
          {
            label: "Serv. al cliente (CS)",
            key: "servCliente",
            minWidth: 150,
            maxWidth: 150,
            className: "col-md-3 col-lg-1 col-sm-6",
          },
          {
            label: "Cliente",
            key: "cliente",
            minWidth: 150,
            maxWidth: 150,
            className: "col-md-3 col-lg-1 col-sm-6",
          },
          {
            label: "Aduana",
            key: "aduana",
            minWidth: 150,
            maxWidth: 150,
            className: "col-md-3 col-lg-1 col-sm-6",
          },
          {
            label: "Medio transporte internacional",
            key: "transportInternacional",
            minWidth: 150,
            maxWidth: 150,
            className: "col-md-3 col-lg-1 col-sm-6",
          },
          {
            label: "Doc transporte",
            key: "docTransporte",
            minWidth: 150,
            maxWidth: 150,
            className: "col-md-3 col-lg-1 col-sm-6",
          },
          {
            label: "Proveedor",
            key: "nombreProveedor",
            minWidth: 150,
            maxWidth: 150,
            className: "col-md-3 col-lg-1 col-sm-6",
          },
          {
            label: "No. de factura(s)",
            key: "noFactura",
            minWidth: 150,
            maxWidth: 170,
            limitString: 20,
            className: "col-md-3 col-lg-2 col-sm-6",
            custom: (value) => ({
              content:
                value?.noFactura?.length > 20 ? (
                  <Popup
                    content={value?.noFactura}
                    key={value?.noFactura}
                    popperModifiers={{
                      preventOverflow: {
                        boundariesElement: "offsetParent",
                      },
                    }}
                    positionFixed={true}
                    position="top center"
                    size="mini"
                    trigger={
                      <span>{`${value?.noFactura.substring(0, 17)}...`}</span>
                    }
                  />
                ) : (
                  <span>{value?.noFactura}</span>
                ),
            }),
          },
          {
            label: "Tipo de trámite",
            key: "tipoTramite",
            minWidth: 150,
            maxWidth: 150,
            className: "col-md-3 col-lg-1 col-sm-6",
          },
          {
            label: "Fecha de aceptación",
            key: "fechaAceptacion",
            minWidth: 150,
            maxWidth: 150,
            className: "col-md-3 col-lg-1 col-sm-6",
          },
          {
            label: "ETA",
            key: "eta",
            minWidth: 150,
            maxWidth: 150,
            className: "col-md-3 col-lg-1 col-sm-6",
          },
          {
            label: "Fecha llegada M/CIA",
            key: "fechaLlegadaMcia",
            minWidth: 150,
            maxWidth: 150,
            className: "col-md-3 col-lg-1 col-sm-6",
          },
          {
            label: "Fecha Doc. completos",
            key: "fechaDocCompletos",
            minWidth: 150,
            maxWidth: 150,
            className: "col-md-3 col-lg-1 col-sm-6",
          },
          {
            label: "Fecha de fin descargue M/CIA",
            key: "fechaFinDescargueMcia",
            minWidth: 150,
            maxWidth: 150,
            className: "col-md-3 col-lg-1 col-sm-6",
          },
          {
            label: "Cantidad DIM",
            key: "cantidadDeclaraciones",
            minWidth: 150,
            maxWidth: 150,
            className: "col-md-3 col-lg-1 col-sm-6",
          },
          {
            label: "Fecha máxima de pago",
            key: "fechaMaximaPago",
            minWidth: 150,
            maxWidth: 150,
            className: "col-md-3 col-lg-1 col-sm-6",
            className: "col-md-3 col-lg-2 col-sm-6",
            custom: (value) => {
              return {
                backgroundColor: value.hex,
                content: <span>{value["fechaMaximaPago"]}</span>,
              };
            },
          },
        ],
        3: [
          {
            label: "DO",
            key: "dosId",
            minWidth: 150,
            maxWidth: 170,
            limitString: 20,
            className: "col-md-3 col-lg-2 col-sm-6",
            custom: (value) => ({
              content:
                value.dosId.length > 20 ? (
                  <Popup
                    content={value.dosId}
                    key={value.dosId}
                    popperModifiers={{
                      preventOverflow: {
                        boundariesElement: "offsetParent",
                      },
                    }}
                    positionFixed={true}
                    position="top center"
                    size="mini"
                    trigger={
                      <Link
                        style={{ color: "#003F70", fontWeight: "bold" }}
                        to={`/custom-detail-view/` + value.id}
                      >
                        {`${value.dosId.substring(0, 17)}...`}
                      </Link>
                    }
                  />
                ) : (
                  <Link
                    style={{ color: "#003F70", fontWeight: "bold" }}
                    to={`/custom-detail-view/` + value.id}
                  >
                    {value.dosId}
                  </Link>
                ),
            }),
          },
          {
            label: "Pedido",
            key: "pedido",
            minWidth: 150,
            maxWidth: 170,
            limitString: 20,
            className: "col-md-3 col-lg-2 col-sm-6",
            custom: (value) => ({
              content:
                value?.pedido?.length > 20 ? (
                  <Popup
                    content={value?.pedido}
                    key={value?.pedido}
                    popperModifiers={{
                      preventOverflow: {
                        boundariesElement: "offsetParent",
                      },
                    }}
                    positionFixed={true}
                    position="top center"
                    size="mini"
                    trigger={
                      <span>{`${value?.pedido.substring(0, 17)}...`}</span>
                    }
                  />
                ) : (
                  <span>{value?.pedido}</span>
                ),
            }),
          },
          {
            label: "Serv. al cliente (CS)",
            key: "duenoDo",
            minWidth: 150,
            maxWidth: 150,
            className: "col-md-3 col-lg-1 col-sm-6",
          },
          {
            label: "Cliente",
            key: "razonSocial",
            minWidth: 150,
            maxWidth: 150,
            className: "col-md-3 col-lg-1 col-sm-6",
          },
          {
            label: "Aduana",
            key: "aduanaDeclaracion",
            minWidth: 150,
            maxWidth: 150,
            className: "col-md-3 col-lg-1 col-sm-6",
          },
          {
            label: "Deposito",
            key: "NombreDeposito",
            minWidth: 150,
            maxWidth: 150,
            className: "col-md-3 col-lg-1 col-sm-6",
          },
          {
            label: "Medio transporte internacional",
            key: "viaNombre",
            minWidth: 150,
            maxWidth: 150,
            className: "col-md-3 col-lg-1 col-sm-6",
          },
          {
            label: "Doc transporte",
            key: "documentoTransporte",
            minWidth: 150,
            maxWidth: 150,
            className: "col-md-3 col-lg-1 col-sm-6",
          },
          {
            label: "Proveedor",
            key: "nombreProveedor",
            minWidth: 150,
            maxWidth: 150,
            className: "col-md-3 col-lg-1 col-sm-6",
          },
          {
            label: "No. de factura(s)",
            key: "numeroFactura",
            minWidth: 150,
            maxWidth: 170,
            limitString: 20,
            className: "col-md-3 col-lg-2 col-sm-6",
            custom: (value) => ({
              content:
                value?.numeroFactura?.length > 20 ? (
                  <Popup
                    content={value?.numeroFactura}
                    key={value?.numeroFactura}
                    popperModifiers={{
                      preventOverflow: {
                        boundariesElement: "offsetParent",
                      },
                    }}
                    positionFixed={true}
                    position="top center"
                    size="mini"
                    trigger={
                      <span>{`${value?.numeroFactura.substring(
                        0,
                        17,
                      )}...`}</span>
                    }
                  />
                ) : (
                  <span>{value?.numeroFactura}</span>
                ),
            }),
          },
          {
            label: "Fecha de aceptación",
            key: "fechaAceptacion",
            minWidth: 150,
            maxWidth: 150,
            className: "col-md-3 col-lg-1 col-sm-6",
          },
          {
            label: "Fecha llegada M/CIA",
            key: "fechaLlegadaMcia",
            minWidth: 150,
            maxWidth: 150,
            className: "col-md-3 col-lg-1 col-sm-6",
          },
          {
            label: "Fecha Manifiesto de Carga",
            key: "ManifiestoCargaFecha",
            minWidth: 150,
            maxWidth: 150,
            className: "col-md-3 col-lg-1 col-sm-6",
          },
          {
            label: "Fecha Doc. completos",
            key: "fechaDocCompletos",
            minWidth: 150,
            maxWidth: 150,
            className: "col-md-3 col-lg-1 col-sm-6",
          },
          {
            label: "Fecha de fin descargue M/CIA",
            key: "fechaFinDescargueMcia",
            minWidth: 150,
            maxWidth: 150,
            className: "col-md-3 col-lg-1 col-sm-6",
          },
          {
            label: "Fecha consulta de inventario",
            key: "fechaConsultaInventario",
            minWidth: 150,
            maxWidth: 150,
            className: "col-md-3 col-lg-1 col-sm-6",
          },
          {
            label: "Cantidad ítems",
            key: "cantidadItems",
            minWidth: 150,
            maxWidth: 150,
            className: "col-md-3 col-lg-1 col-sm-6",
          },
          {
            label: "Fecha de pago o sticker",
            key: "fechaPagoSticker",
            minWidth: 150,
            maxWidth: 150,
            className: "col-md-3 col-lg-1 col-sm-6",
          },
          {
            label: "Cantidad DIM",
            key: "cantidadDim",
            minWidth: 150,
            maxWidth: 150,
            className: "col-md-3 col-lg-1 col-sm-6",
          },
          {
            label: "Tiene prórroga",
            key: "prorroga",
            minWidth: 150,
            maxWidth: 150,
            className: "col-md-3 col-lg-1 col-sm-6",
          },
          {
            label: "Fecha doc transporte",
            key: "documentoTransporteFechaLC",
            minWidth: 150,
            maxWidth: 150,
            className: "col-md-3 col-lg-1 col-sm-6",
          },
          {
            label: "Fecha factura comercial",
            key: "facturaComercialFechaLC",
            minWidth: 150,
            maxWidth: 150,
            className: "col-md-3 col-lg-1 col-sm-6",
          },
          {
            label: "Fecha certificado origen",
            key: "certificadoOrigenFechaLC",
            minWidth: 150,
            maxWidth: 150,
            className: "col-md-3 col-lg-1 col-sm-6",
          },
          {
            label: "Fecha consulta inventario",
            key: "consultaInventarioFechaLC",
            minWidth: 150,
            maxWidth: 150,
            className: "col-md-3 col-lg-1 col-sm-6",
          },
          {
            label: "Fecha certificado ICA",
            key: "certificadoInspeccionICAFechaLC",
            minWidth: 150,
            maxWidth: 150,
            className: "col-md-3 col-lg-1 col-sm-6",
          },
          {
            label: "Fecha certificado INVIMA",
            key: "certificadoInspeccionInvimaFechaLC",
            minWidth: 150,
            maxWidth: 150,
            className: "col-md-3 col-lg-1 col-sm-6",
          },
          {
            label: "Registro de importación",
            key: "registroImportacionFechaLC",
            minWidth: 150,
            maxWidth: 150,
            className: "col-md-3 col-lg-1 col-sm-6",
          },
          {
            label: "Fecha máxima levante",
            key: "fechaMaximaLevante",
            minWidth: 150,
            maxWidth: 150,
            className: "col-md-3 col-lg-1 col-sm-6",
            className: "col-md-3 col-lg-2 col-sm-6",
            custom: (value) => {
              return {
                backgroundColor: value.hex,
                content: <span>{value["fechaMaximaLevante"]}</span>,
              };
            },
          },
        ],
        5: [
          {
            label: "DO",
            key: "dosId",
            minWidth: 150,
            maxWidth: 170,
            limitString: 20,
            className: "col-md-3 col-lg-2 col-sm-6",
            custom: (value) => ({
              content:
                value.dosId.length > 20 ? (
                  <Popup
                    content={value.dosId}
                    key={value.dosId}
                    popperModifiers={{
                      preventOverflow: {
                        boundariesElement: "offsetParent",
                      },
                    }}
                    positionFixed={true}
                    position="top center"
                    size="mini"
                    trigger={
                      <Link
                        style={{ color: "#003F70", fontWeight: "bold" }}
                        to={`/custom-detail-view/` + value.id}
                      >
                        {`${value.dosId.substring(0, 17)}...`}
                      </Link>
                    }
                  />
                ) : (
                  <Link
                    style={{ color: "#003F70", fontWeight: "bold" }}
                    to={`/custom-detail-view/` + value.id}
                  >
                    {value.dosId}
                  </Link>
                ),
            }),
          },
          {
            label: "Pedido",
            key: "pedido",
            minWidth: 150,
            maxWidth: 170,
            limitString: 20,
            className: "col-md-3 col-lg-2 col-sm-6",
            custom: (value) => ({
              content:
                value?.pedido?.length > 20 ? (
                  <Popup
                    content={value?.pedido}
                    key={value?.pedido}
                    popperModifiers={{
                      preventOverflow: {
                        boundariesElement: "offsetParent",
                      },
                    }}
                    positionFixed={true}
                    position="top center"
                    size="mini"
                    trigger={
                      <span>{`${value?.pedido.substring(0, 17)}...`}</span>
                    }
                  />
                ) : (
                  <span>{value?.pedido}</span>
                ),
            }),
          },
          {
            label: "Serv. al cliente (CS)",
            key: "ServCliente",
            minWidth: 150,
            maxWidth: 150,
            className: "col-md-3 col-lg-1 col-sm-6",
          },
          {
            label: "Cliente",
            key: "cliente",
            minWidth: 150,
            maxWidth: 150,
            className: "col-md-3 col-lg-1 col-sm-6",
          },
          {
            label: "Medio transporte internacional",
            key: "medioTransporteInternacional",
            minWidth: 150,
            maxWidth: 150,
            className: "col-md-3 col-lg-1 col-sm-6",
          },
          {
            label: "Aduana de partida",
            key: "AduanaPartida",
            minWidth: 150,
            maxWidth: 150,
            className: "col-md-3 col-lg-1 col-sm-6",
          },
          {
            label: "Aduana de destino",
            key: "AduanaDestino",
            minWidth: 150,
            maxWidth: 150,
            className: "col-md-3 col-lg-1 col-sm-6",
          },
          {
            label: "Doc transporte",
            key: "docTransporte",
            minWidth: 150,
            maxWidth: 150,
            className: "col-md-3 col-lg-1 col-sm-6",
          },
          {
            label: "Fecha llegada M/CIA",
            key: "fechaLlegadaMcia",
            minWidth: 150,
            maxWidth: 150,
            className: "col-md-3 col-lg-1 col-sm-6",
          },
          {
            label: "Fecha de fin descargue M/CIA",
            key: "fechaFinDescargueMcia",
            minWidth: 150,
            maxWidth: 150,
            className: "col-md-3 col-lg-1 col-sm-6",
          },
          {
            label: "No. Autorización DTA",
            key: "noAutorizacionDta",
            minWidth: 150,
            maxWidth: 150,
            className: "col-md-3 col-lg-1 col-sm-6",
          },
          {
            label: "Transporte local",
            key: "transporteLocal",
            minWidth: 150,
            maxWidth: 150,
            className: "col-md-3 col-lg-1 col-sm-6",
          },
          {
            label: "Fecha de despacho",
            key: "fechaDespacho",
            minWidth: 150,
            maxWidth: 150,
            className: "col-md-3 col-lg-1 col-sm-6",
          },
          {
            label: "Fecha máxima autorización modalidad",
            key: "fechaMaximaAutorizacionModalidad",
            minWidth: 150,
            maxWidth: 150,
            className: "col-md-3 col-lg-1 col-sm-6",
            className: "col-md-3 col-lg-2 col-sm-6",
            custom: (value) => {
              return {
                backgroundColor: value.hex,
                content: (
                  <span>{value["fechaMaximaAutorizacionModalidad"]}</span>
                ),
              };
            },
          },
        ],
        7: [
          {
            label: "DO",
            key: "do",
            minWidth: 150,
            maxWidth: 170,
            limitString: 20,
            className: "col-md-3 col-lg-2 col-sm-6",
            custom: (value) => ({
              content:
                value.do.length > 20 ? (
                  <Popup
                    content={value.do}
                    key={value.do}
                    popperModifiers={{
                      preventOverflow: {
                        boundariesElement: "offsetParent",
                      },
                    }}
                    positionFixed={true}
                    position="top center"
                    size="mini"
                    trigger={
                      <Link
                        style={{ color: "#003F70", fontWeight: "bold" }}
                        to={`/custom-detail-view/` + value.id}
                      >
                        {`${value.do.substring(0, 17)}...`}
                      </Link>
                    }
                  />
                ) : (
                  <Link
                    style={{ color: "#003F70", fontWeight: "bold" }}
                    to={`/custom-detail-view/` + value.id}
                  >
                    {value.do}
                  </Link>
                ),
            }),
          },
          {
            label: "Pedido",
            key: "pedido",
            minWidth: 150,
            maxWidth: 170,
            limitString: 20,
            className: "col-md-3 col-lg-2 col-sm-6",
            custom: (value) => ({
              content:
                value?.pedido?.length > 20 ? (
                  <Popup
                    content={value?.pedido}
                    key={value?.pedido}
                    popperModifiers={{
                      preventOverflow: {
                        boundariesElement: "offsetParent",
                      },
                    }}
                    positionFixed={true}
                    position="top center"
                    size="mini"
                    trigger={
                      <span>{`${value?.pedido.substring(0, 17)}...`}</span>
                    }
                  />
                ) : (
                  <span>{value?.pedido}</span>
                ),
            }),
          },
          {
            label: "Proveedor",
            key: "nombreProveedor",
            minWidth: 150,
            maxWidth: 150,
            className: "col-md-3 col-lg-1 col-sm-6",
          },
          {
            label: "Serv. al cliente (CS)",
            key: "servCliente",
            minWidth: 150,
            maxWidth: 150,
            className: "col-md-3 col-lg-1 col-sm-6",
          },
          {
            label: "Cliente",
            key: "cliente",
            minWidth: 150,
            maxWidth: 150,
            className: "col-md-3 col-lg-1 col-sm-6",
          },
          {
            label: "Fecha máxima ETA",
            key: "fechaMaximaETA",
            minWidth: 150,
            maxWidth: 150,
            className: "col-md-3 col-lg-1 col-sm-6",
            className: "col-md-3 col-lg-2 col-sm-6",
            custom: (value) => {
              return {
                backgroundColor: value.hex,
                content: <span>{value["fechaMaximaETA"]}</span>,
              };
            },
          },
        ],
        8: [
          {
            label: "DO",
            key: "do",
            minWidth: 150,
            maxWidth: 170,
            limitString: 20,
            className: "col-md-3 col-lg-2 col-sm-6",
            custom: (value) => ({
              content:
                value?.do?.length > 20 ? (
                  <Popup
                    content={value.do}
                    key={value.do}
                    popperModifiers={{
                      preventOverflow: {
                        boundariesElement: "offsetParent",
                      },
                    }}
                    positionFixed={true}
                    position="top center"
                    size="mini"
                    trigger={
                      <Link
                        style={{ color: "#003F70", fontWeight: "bold" }}
                        to={`/custom-detail-view/` + value.id}
                      >
                        {`${value.do.substring(0, 17)}...`}
                      </Link>
                    }
                  />
                ) : (
                  <Link
                    style={{ color: "#003F70", fontWeight: "bold" }}
                    to={`/custom-detail-view/` + value.id}
                  >
                    {value.do}
                  </Link>
                ),
            }),
          },
          {
            label: "Pedido",
            key: "pedido",
            minWidth: 150,
            maxWidth: 170,
            limitString: 20,
            className: "col-md-3 col-lg-2 col-sm-6",
            custom: (value) => ({
              content:
                value?.pedido?.length > 20 ? (
                  <Popup
                    content={value?.pedido}
                    key={value?.pedido}
                    popperModifiers={{
                      preventOverflow: {
                        boundariesElement: "offsetParent",
                      },
                    }}
                    positionFixed={true}
                    position="top center"
                    size="mini"
                    trigger={
                      <span>{`${value?.pedido.substring(0, 17)}...`}</span>
                    }
                  />
                ) : (
                  <span>{value?.pedido}</span>
                ),
            }),
          },
          {
            label: "Serv. al cliente (CS)",
            key: "servCliente",
            minWidth: 150,
            maxWidth: 150,
            className: "col-md-3 col-lg-1 col-sm-6",
          },
          {
            label: "Cliente",
            key: "cliente",
            minWidth: 150,
            maxWidth: 150,
            className: "col-md-3 col-lg-1 col-sm-6",
          },
          {
            label: "Proveedor",
            key: "proveedor",
            minWidth: 150,
            maxWidth: 150,
            className: "col-md-3 col-lg-1 col-sm-6",
          },
          {
            label: "ETA",
            key: "ETA",
            minWidth: 150,
            maxWidth: 150,
            className: "col-md-3 col-lg-1 col-sm-6",
          },
          {
            label: "No. de factura(s)",
            key: "noFactura",
            minWidth: 150,
            maxWidth: 170,
            limitString: 20,
            className: "col-md-3 col-lg-2 col-sm-6",
            custom: (value) => ({
              content:
                value?.noFactura?.length > 20 ? (
                  <Popup
                    content={value?.noFactura}
                    key={value?.noFactura}
                    popperModifiers={{
                      preventOverflow: {
                        boundariesElement: "offsetParent",
                      },
                    }}
                    positionFixed={true}
                    position="top center"
                    size="mini"
                    trigger={
                      <span>{`${value?.noFactura.substring(0, 17)}...`}</span>
                    }
                  />
                ) : (
                  <span>{value?.noFactura}</span>
                ),
            }),
          },
          {
            label: "Fecha llegada M/CIA",
            key: "fechaLlegadaMCIA",
            minWidth: 150,
            maxWidth: 150,
            className: "col-md-3 col-lg-1 col-sm-6",
          },
          {
            label: "Fecha de fin descargue M/CIA",
            key: "fechaFindescargueMCIA",
            minWidth: 150,
            maxWidth: 150,
            className: "col-md-3 col-lg-1 col-sm-6",
          },
          {
            label: "Fecha máxima DocTrans",
            key: "fechaMaximaDocTrans",
            minWidth: 150,
            maxWidth: 150,
            className: "col-md-3 col-lg-1 col-sm-6",
            className: "col-md-3 col-lg-2 col-sm-6",
            custom: (value) => {
              return {
                backgroundColor: value.hex,
                content: <span>{value["fechaMaximaDocTrans"]}</span>,
              };
            },
          },
        ],
        10: [
          {
            label: "DO",
            key: "do",
            minWidth: 150,
            maxWidth: 170,
            limitString: 20,
            className: "col-md-3 col-lg-2 col-sm-6",
            custom: (value) => ({
              content:
                value?.do?.length > 20 ? (
                  <Popup
                    content={value.do}
                    key={value.do}
                    popperModifiers={{
                      preventOverflow: {
                        boundariesElement: "offsetParent",
                      },
                    }}
                    positionFixed={true}
                    position="top center"
                    size="mini"
                    trigger={
                      <Link
                        style={{ color: "#003F70", fontWeight: "bold" }}
                        to={`/custom-detail-view/` + value.id}
                      >
                        {`${value.do.substring(0, 17)}...`}
                      </Link>
                    }
                  />
                ) : (
                  <Link
                    style={{ color: "#003F70", fontWeight: "bold" }}
                    to={`/custom-detail-view/` + value.id}
                  >
                    {value.do}
                  </Link>
                ),
            }),
          },
          {
            label: "Pedido",
            key: "pedido",
            minWidth: 150,
            maxWidth: 170,
            limitString: 20,
            className: "col-md-3 col-lg-2 col-sm-6",
            custom: (value) => ({
              content:
                value?.pedido?.length > 20 ? (
                  <Popup
                    content={value?.pedido}
                    key={value?.pedido}
                    popperModifiers={{
                      preventOverflow: {
                        boundariesElement: "offsetParent",
                      },
                    }}
                    positionFixed={true}
                    position="top center"
                    size="mini"
                    trigger={
                      <span>{`${value?.pedido.substring(0, 17)}...`}</span>
                    }
                  />
                ) : (
                  <span>{value?.pedido}</span>
                ),
            }),
          },
          {
            label: "Serv. al cliente (CS)",
            key: "servCliente",
            minWidth: 150,
            maxWidth: 150,
            className: "col-md-3 col-lg-1 col-sm-6",
          },
          {
            label: "Cliente",
            key: "cliente",
            minWidth: 150,
            maxWidth: 150,
            className: "col-md-3 col-lg-1 col-sm-6",
          },
          {
            label: "Proveedor",
            key: "proveedor",
            minWidth: 150,
            maxWidth: 150,
            className: "col-md-3 col-lg-1 col-sm-6",
          },
          {
            label: "País de origen",
            key: "paisOrigen",
            minWidth: 150,
            maxWidth: 150,
            className: "col-md-3 col-lg-1 col-sm-6",
          },
          {
            label: "ETA",
            key: "ETA",
            minWidth: 150,
            maxWidth: 150,
            className: "col-md-3 col-lg-1 col-sm-6",
          },
          {
            label: "Fecha llegada M/CIA",
            key: "fechaLlegadaMCIA",
            minWidth: 150,
            maxWidth: 150,
            className: "col-md-3 col-lg-1 col-sm-6",
          },
          {
            label: "Fecha de fin descargue M/CIA",
            key: "fechaFinDescargueMCIA",
            minWidth: 150,
            maxWidth: 150,
            className: "col-md-3 col-lg-1 col-sm-6",
          },
          {
            label: "Fecha doc transporte",
            key: "fechaDocTransporte",
            minWidth: 150,
            maxWidth: 150,
            className: "col-md-3 col-lg-1 col-sm-6",
          },
          {
            label: "Fecha factura comercial",
            key: "fechaFacturaComercial",
            minWidth: 150,
            maxWidth: 150,
            className: "col-md-3 col-lg-1 col-sm-6",
          },
          {
            label: "Fecha certificado origen",
            key: "fechaCertificadoOrigen",
            minWidth: 150,
            maxWidth: 150,
            className: "col-md-3 col-lg-1 col-sm-6",
          },
          {
            label: "Fecha consulta inventario",
            key: "fechaConsultaInventario",
            minWidth: 150,
            maxWidth: 150,
            className: "col-md-3 col-lg-1 col-sm-6",
          },
          {
            label: "Fecha certificado ICA",
            key: "fechaCertificadoICA",
            minWidth: 150,
            maxWidth: 150,
            className: "col-md-3 col-lg-1 col-sm-6",
          },
          {
            label: "Fecha certificado INVIMA",
            key: "fechaCertificadoINVIMA",
            minWidth: 150,
            maxWidth: 150,
            className: "col-md-3 col-lg-1 col-sm-6",
          },
          {
            label: "Registro de importación",
            key: "registroImportacion",
            minWidth: 150,
            maxWidth: 150,
            className: "col-md-3 col-lg-1 col-sm-6",
          },
          {
            label: "Fecha máxima docs. completos",
            key: "fechaMaximaDocCompletos",
            minWidth: 150,
            maxWidth: 150,
            className: "col-md-3 col-lg-1 col-sm-6",
            className: "col-md-3 col-lg-2 col-sm-6",
            custom: (value) => {
              return {
                backgroundColor: value.hex,
                content: <span>{value["fechaMaximaDocCompletos"]}</span>,
              };
            },
          },
        ],
        11: [
          {
            label: "DO",
            key: "do",
            minWidth: 150,
            maxWidth: 170,
            limitString: 20,
            className: "col-md-3 col-lg-2 col-sm-6",
            custom: (value) => ({
              content:
                value?.do?.length > 20 ? (
                  <Popup
                    content={value.do}
                    key={value.do}
                    popperModifiers={{
                      preventOverflow: {
                        boundariesElement: "offsetParent",
                      },
                    }}
                    positionFixed={true}
                    position="top center"
                    size="mini"
                    trigger={
                      <Link
                        style={{ color: "#003F70", fontWeight: "bold" }}
                        to={`/custom-detail-view/` + value.id}
                      >
                        {`${value.do.substring(0, 17)}...`}
                      </Link>
                    }
                  />
                ) : (
                  <Link
                    style={{ color: "#003F70", fontWeight: "bold" }}
                    to={`/custom-detail-view/` + value.id}
                  >
                    {value.do}
                  </Link>
                ),
            }),
          },
          {
            label: "Pedido",
            key: "pedido",
            minWidth: 150,
            maxWidth: 170,
            limitString: 20,
            className: "col-md-3 col-lg-2 col-sm-6",
            custom: (value) => ({
              content:
                value?.pedido?.length > 20 ? (
                  <Popup
                    content={value?.pedido}
                    key={value?.pedido}
                    popperModifiers={{
                      preventOverflow: {
                        boundariesElement: "offsetParent",
                      },
                    }}
                    positionFixed={true}
                    position="top center"
                    size="mini"
                    trigger={
                      <span>{`${value?.pedido.substring(0, 17)}...`}</span>
                    }
                  />
                ) : (
                  <span>{value?.pedido}</span>
                ),
            }),
          },
          {
            label: "Serv. al cliente (CS)",
            key: "servCliente",
            minWidth: 150,
            maxWidth: 150,
            className: "col-md-3 col-lg-1 col-sm-6",
          },
          {
            label: "Cliente",
            key: "cliente",
            minWidth: 150,
            maxWidth: 150,
            className: "col-md-3 col-lg-1 col-sm-6",
          },
          {
            label: "Aduana",
            key: "aduana",
            minWidth: 150,
            maxWidth: 150,
            className: "col-md-3 col-lg-1 col-sm-6",
          },
          {
            label: "Medio transporte internacional",
            key: "medioTransporteInternacional",
            minWidth: 150,
            maxWidth: 150,
            className: "col-md-3 col-lg-1 col-sm-6",
          },
          {
            label: "Doc transporte",
            key: "doctransporte",
            minWidth: 150,
            maxWidth: 150,
            className: "col-md-3 col-lg-1 col-sm-6",
          },
          {
            label: "No. de factura(s)",
            key: "noFactura",
            minWidth: 150,
            maxWidth: 170,
            limitString: 20,
            className: "col-md-3 col-lg-2 col-sm-6",
            custom: (value) => ({
              content:
                value?.noFactura?.length > 20 ? (
                  <Popup
                    content={value?.noFactura}
                    key={value?.noFactura}
                    popperModifiers={{
                      preventOverflow: {
                        boundariesElement: "offsetParent",
                      },
                    }}
                    positionFixed={true}
                    position="top center"
                    size="mini"
                    trigger={
                      <span>{`${value?.noFactura.substring(0, 17)}...`}</span>
                    }
                  />
                ) : (
                  <span>{value?.noFactura}</span>
                ),
            }),
          },
          {
            label: "Transporte local",
            key: "transporteLocal",
            minWidth: 150,
            maxWidth: 150,
            className: "col-md-3 col-lg-1 col-sm-6",
          },
          {
            label: 'Cant. Contenedores 20"',
            key: "cantContenedor20",
            minWidth: 150,
            maxWidth: 150,
            className: "col-md-3 col-lg-1 col-sm-6",
          },
          {
            label: 'Cant. Contenedores 40"',
            key: "cantContenedor40",
            minWidth: 150,
            maxWidth: 150,
            className: "col-md-3 col-lg-1 col-sm-6",
          },
          {
            label: "Fecha máxima entrega a transporte",
            key: "fechaMaximaentregaTrans",
            minWidth: 150,
            maxWidth: 150,
            className: "col-md-3 col-lg-1 col-sm-6",
            className: "col-md-3 col-lg-2 col-sm-6",
            custom: (value) => {
              return {
                backgroundColor: value.hex,
                content: <span>{value["fechaMaximaentregaTrans"]}</span>,
              };
            },
          },
        ],
        12: [
          {
            label: "DO",
            key: "do",
            minWidth: 150,
            maxWidth: 170,
            limitString: 20,
            className: "col-md-3 col-lg-2 col-sm-6",
            custom: (value) => ({
              content:
                value?.do?.length > 20 ? (
                  <Popup
                    content={value.do}
                    key={value.do}
                    popperModifiers={{
                      preventOverflow: {
                        boundariesElement: "offsetParent",
                      },
                    }}
                    positionFixed={true}
                    position="top center"
                    size="mini"
                    trigger={
                      <Link
                        style={{ color: "#003F70", fontWeight: "bold" }}
                        to={`/custom-detail-view/` + value.id}
                      >
                        {`${value.do.substring(0, 17)}...`}
                      </Link>
                    }
                  />
                ) : (
                  <Link
                    style={{ color: "#003F70", fontWeight: "bold" }}
                    to={`/custom-detail-view/` + value.id}
                  >
                    {value.do}
                  </Link>
                ),
            }),
          },
          {
            label: "Pedido",
            key: "pedido",
            minWidth: 150,
            maxWidth: 170,
            limitString: 20,
            className: "col-md-3 col-lg-2 col-sm-6",
            custom: (value) => ({
              content:
                value?.pedido?.length > 20 ? (
                  <Popup
                    content={value?.pedido}
                    key={value?.pedido}
                    popperModifiers={{
                      preventOverflow: {
                        boundariesElement: "offsetParent",
                      },
                    }}
                    positionFixed={true}
                    position="top center"
                    size="mini"
                    trigger={
                      <span>{`${value?.pedido.substring(0, 17)}...`}</span>
                    }
                  />
                ) : (
                  <span>{value?.pedido}</span>
                ),
            }),
          },
          {
            label: "Serv. al cliente (CS)",
            key: "servCliente",
            minWidth: 150,
            maxWidth: 150,
            className: "col-md-3 col-lg-1 col-sm-6",
          },
          {
            label: "Cliente",
            key: "cliente",
            minWidth: 150,
            maxWidth: 150,
            className: "col-md-3 col-lg-1 col-sm-6",
          },
          {
            label: "Aduana",
            key: "aduana",
            minWidth: 150,
            maxWidth: 150,
            className: "col-md-3 col-lg-1 col-sm-6",
          },
          {
            label: "Medio transporte internacional",
            key: "medioTransporteInternacional",
            minWidth: 150,
            maxWidth: 150,
            className: "col-md-3 col-lg-1 col-sm-6",
          },
          {
            label: "Doc transporte",
            key: "doctransporte",
            minWidth: 150,
            maxWidth: 150,
            className: "col-md-3 col-lg-1 col-sm-6",
          },
          {
            label: "No. de factura(s)",
            key: "noFactura",
            minWidth: 150,
            maxWidth: 170,
            limitString: 20,
            className: "col-md-3 col-lg-2 col-sm-6",
            custom: (value) => ({
              content:
                value?.noFactura?.length > 20 ? (
                  <Popup
                    content={value?.noFactura}
                    key={value?.noFactura}
                    popperModifiers={{
                      preventOverflow: {
                        boundariesElement: "offsetParent",
                      },
                    }}
                    positionFixed={true}
                    position="top center"
                    size="mini"
                    trigger={
                      <span>{`${value?.noFactura.substring(0, 17)}...`}</span>
                    }
                  />
                ) : (
                  <span>{value?.noFactura}</span>
                ),
            }),
          },
          {
            label: "Fecha entrega a transportador",
            key: "fechaEntregaATransportador",
            minWidth: 150,
            maxWidth: 150,
            className: "col-md-3 col-lg-1 col-sm-6",
          },
          {
            label: "Transporte local",
            key: "transporteLocal",
            minWidth: 150,
            maxWidth: 150,
            className: "col-md-3 col-lg-1 col-sm-6",
          },
          {
            label: 'Cant. Contenedores 20"',
            key: "cantContenedor20",
            minWidth: 150,
            maxWidth: 150,
            className: "col-md-3 col-lg-1 col-sm-6",
          },
          {
            label: 'Cant. Contenedores 40"',
            key: "cantContenedor40",
            minWidth: 150,
            maxWidth: 150,
            className: "col-md-3 col-lg-1 col-sm-6",
          },
          {
            label: "Fecha máxima despacho",
            key: "fechaMaximaDespacho",
            minWidth: 150,
            maxWidth: 150,
            className: "col-md-3 col-lg-1 col-sm-6",
            className: "col-md-3 col-lg-2 col-sm-6",
            custom: (value) => {
              return {
                backgroundColor: value.hex,
                content: <span>{value["fechaMaximaDespacho"]}</span>,
              };
            },
          },
        ],
        13: [
          {
            label: "DO",
            key: "do",
            minWidth: 150,
            maxWidth: 170,
            limitString: 20,
            className: "col-md-3 col-lg-2 col-sm-6",
            custom: (value) => ({
              content:
                value?.do?.length > 20 ? (
                  <Popup
                    content={value.do}
                    key={value.do}
                    popperModifiers={{
                      preventOverflow: {
                        boundariesElement: "offsetParent",
                      },
                    }}
                    positionFixed={true}
                    position="top center"
                    size="mini"
                    trigger={
                      <Link
                        style={{ color: "#003F70", fontWeight: "bold" }}
                        to={`/custom-detail-view/` + value.id}
                      >
                        {`${value.do.substring(0, 17)}...`}
                      </Link>
                    }
                  />
                ) : (
                  <Link
                    style={{ color: "#003F70", fontWeight: "bold" }}
                    to={`/custom-detail-view/` + value.id}
                  >
                    {value.do}
                  </Link>
                ),
            }),
          },
          {
            label: "Pedido",
            key: "pedido",
            minWidth: 150,
            maxWidth: 170,
            limitString: 20,
            className: "col-md-3 col-lg-2 col-sm-6",
            custom: (value) => ({
              content:
                value?.pedido?.length > 20 ? (
                  <Popup
                    content={value?.pedido}
                    key={value?.pedido}
                    popperModifiers={{
                      preventOverflow: {
                        boundariesElement: "offsetParent",
                      },
                    }}
                    positionFixed={true}
                    position="top center"
                    size="mini"
                    trigger={
                      <span>{`${value?.pedido.substring(0, 17)}...`}</span>
                    }
                  />
                ) : (
                  <span>{value?.pedido}</span>
                ),
            }),
          },
          {
            label: "Serv. al cliente (CS)",
            key: "servCliente",
            minWidth: 150,
            maxWidth: 150,
            className: "col-md-3 col-lg-1 col-sm-6",
          },
          {
            label: "Cliente",
            key: "cliente",
            minWidth: 150,
            maxWidth: 150,
            className: "col-md-3 col-lg-1 col-sm-6",
          },
          {
            label: "Tipo de trámite",
            key: "tipoTramite",
            minWidth: 150,
            maxWidth: 150,
            className: "col-md-3 col-lg-1 col-sm-6",
          },
          {
            label: "Aduana",
            key: "aduana",
            minWidth: 150,
            maxWidth: 150,
            className: "col-md-3 col-lg-1 col-sm-6",
          },
          {
            label: "Tipo declaración",
            key: "tipoDeclaracion",
            minWidth: 150,
            maxWidth: 150,
            className: "col-md-3 col-lg-1 col-sm-6",
          },
          {
            label: "Doc transporte",
            key: "doctransporte",
            minWidth: 150,
            maxWidth: 150,
            className: "col-md-3 col-lg-1 col-sm-6",
          },
          {
            label: "Proveedor",
            key: "nombreProveedor",
            minWidth: 150,
            maxWidth: 150,
            className: "col-md-3 col-lg-1 col-sm-6",
          },
          {
            label: "No. de factura(s)",
            key: "noFactura",
            minWidth: 150,
            maxWidth: 170,
            limitString: 20,
            className: "col-md-3 col-lg-2 col-sm-6",
            custom: (value) => ({
              content:
                value?.noFactura?.length > 20 ? (
                  <Popup
                    content={value?.noFactura}
                    key={value?.noFactura}
                    popperModifiers={{
                      preventOverflow: {
                        boundariesElement: "offsetParent",
                      },
                    }}
                    positionFixed={true}
                    position="top center"
                    size="mini"
                    trigger={
                      <span>{`${value?.noFactura.substring(0, 17)}...`}</span>
                    }
                  />
                ) : (
                  <span>{value?.noFactura}</span>
                ),
            }),
          },
          {
            label: "ETA",
            key: "ETA",
            minWidth: 150,
            maxWidth: 150,
            className: "col-md-3 col-lg-1 col-sm-6",
          },
          {
            label: "Fecha llegada M/CIA",
            key: "fechaLlegadaMCIA",
            minWidth: 150,
            maxWidth: 150,
            className: "col-md-3 col-lg-1 col-sm-6",
          },
          {
            label: "Depósito",
            key: "deposito",
            minWidth: 150,
            maxWidth: 150,
            className: "col-md-3 col-lg-1 col-sm-6",
          },
          {
            label: 'Cant. Contenedores 20"',
            key: "cantContenedor20",
            minWidth: 150,
            maxWidth: 150,
            className: "col-md-3 col-lg-1 col-sm-6",
          },
          {
            label: 'Cant. Contenedores 40"',
            key: "cantContenedor40",
            minWidth: 150,
            maxWidth: 150,
            className: "col-md-3 col-lg-1 col-sm-6",
          },
          {
            label: "Fecha máxima anticipo",
            key: "fechaMaximaAnticipo",
            minWidth: 150,
            maxWidth: 150,
            className: "col-md-3 col-lg-1 col-sm-6",
            className: "col-md-3 col-lg-2 col-sm-6",
            custom: (value) => {
              return {
                backgroundColor: value.hex,
                content: <span>{value["fechaMaximaAnticipo"]}</span>,
              };
            },
          },
        ],
        14: [
          {
            label: "DO",
            key: "do",
            minWidth: 150,
            maxWidth: 170,
            limitString: 20,
            className: "col-md-3 col-lg-2 col-sm-6",
            custom: (value) => ({
              content:
                value?.do?.length > 20 ? (
                  <Popup
                    content={value.do}
                    key={value.do}
                    popperModifiers={{
                      preventOverflow: {
                        boundariesElement: "offsetParent",
                      },
                    }}
                    positionFixed={true}
                    position="top center"
                    size="mini"
                    trigger={
                      <Link
                        style={{ color: "#003F70", fontWeight: "bold" }}
                        to={`/custom-detail-view/` + value.id}
                      >
                        {`${value.do.substring(0, 17)}...`}
                      </Link>
                    }
                  />
                ) : (
                  <Link
                    style={{ color: "#003F70", fontWeight: "bold" }}
                    to={`/custom-detail-view/` + value.id}
                  >
                    {value.do}
                  </Link>
                ),
            }),
          },
          {
            label: "Pedido",
            key: "pedido",
            minWidth: 150,
            maxWidth: 170,
            limitString: 20,
            className: "col-md-3 col-lg-2 col-sm-6",
            custom: (value) => ({
              content:
                value?.pedido?.length > 20 ? (
                  <Popup
                    content={value?.pedido}
                    key={value?.pedido}
                    popperModifiers={{
                      preventOverflow: {
                        boundariesElement: "offsetParent",
                      },
                    }}
                    positionFixed={true}
                    position="top center"
                    size="mini"
                    trigger={
                      <span>{`${value?.pedido.substring(0, 17)}...`}</span>
                    }
                  />
                ) : (
                  <span>{value?.pedido}</span>
                ),
            }),
          },
          {
            label: "Serv. al cliente (CS)",
            key: "servCliente",
            minWidth: 150,
            maxWidth: 150,
            className: "col-md-3 col-lg-1 col-sm-6",
          },
          {
            label: "Cliente",
            key: "cliente",
            minWidth: 150,
            maxWidth: 150,
            className: "col-md-3 col-lg-1 col-sm-6",
          },
          {
            label: "Aduana",
            key: "aduana",
            minWidth: 150,
            maxWidth: 150,
            className: "col-md-3 col-lg-1 col-sm-6",
          },
          {
            label: "Medio transporte internacional",
            key: "medioTransporteInternacional",
            minWidth: 150,
            maxWidth: 150,
            className: "col-md-3 col-lg-1 col-sm-6",
          },
          {
            label: "Fecha levante",
            key: "fechaLevante",
            minWidth: 150,
            maxWidth: 150,
            className: "col-md-3 col-lg-1 col-sm-6",
          },
          {
            label: "Depósito",
            key: "deposito",
            minWidth: 150,
            maxWidth: 150,
            className: "col-md-3 col-lg-1 col-sm-6",
          },
          {
            label: "Fecha despacho total",
            key: "fechaDespachoTotal",
            minWidth: 150,
            maxWidth: 150,
            className: "col-md-3 col-lg-1 col-sm-6",
          },
          {
            label: "Anticipo recibido",
            key: "anticipoRecibido",
            minWidth: 150,
            maxWidth: 150,
            className: "col-md-3 col-lg-1 col-sm-6",
          },
          {
            label: "Fecha máxima facturación",
            key: "fechaMaximaFacturacion",
            minWidth: 150,
            maxWidth: 150,
            className: "col-md-3 col-lg-1 col-sm-6",
            className: "col-md-3 col-lg-2 col-sm-6",
            custom: (value) => {
              return {
                backgroundColor: value.hex,
                content: <span>{value["fechaMaximaFacturacion"]}</span>,
              };
            },
          },
        ],
        15: [
          {
            label: "DO",
            key: "do",
            minWidth: 150,
            maxWidth: 170,
            limitString: 20,
            className: "col-md-3 col-lg-2 col-sm-6",
            custom: (value) => ({
              content:
                value?.do?.length > 20 ? (
                  <Popup
                    content={value.do}
                    key={value.do}
                    popperModifiers={{
                      preventOverflow: {
                        boundariesElement: "offsetParent",
                      },
                    }}
                    positionFixed={true}
                    position="top center"
                    size="mini"
                    trigger={
                      <Link
                        style={{ color: "#003F70", fontWeight: "bold" }}
                        to={`/custom-detail-view/` + value.id}
                      >
                        {`${value.do.substring(0, 17)}...`}
                      </Link>
                    }
                  />
                ) : (
                  <Link
                    style={{ color: "#003F70", fontWeight: "bold" }}
                    to={`/custom-detail-view/` + value.id}
                  >
                    {value.do}
                  </Link>
                ),
            }),
          },
          {
            label: "Pedido",
            key: "pedido",
            minWidth: 150,
            maxWidth: 170,
            limitString: 20,
            className: "col-md-3 col-lg-2 col-sm-6",
            custom: (value) => ({
              content:
                value?.pedido?.length > 20 ? (
                  <Popup
                    content={value?.pedido}
                    key={value?.pedido}
                    popperModifiers={{
                      preventOverflow: {
                        boundariesElement: "offsetParent",
                      },
                    }}
                    positionFixed={true}
                    position="top center"
                    size="mini"
                    trigger={
                      <span>{`${value?.pedido.substring(0, 17)}...`}</span>
                    }
                  />
                ) : (
                  <span>{value?.pedido}</span>
                ),
            }),
          },
          {
            label: "Serv. al cliente (CS)",
            key: "servCliente",
            minWidth: 150,
            maxWidth: 150,
            className: "col-md-3 col-lg-1 col-sm-6",
          },
          {
            label: "Cliente",
            key: "cliente",
            minWidth: 150,
            maxWidth: 150,
            className: "col-md-3 col-lg-1 col-sm-6",
          },
          {
            label: "Aduana",
            key: "aduana",
            minWidth: 150,
            maxWidth: 150,
            className: "col-md-3 col-lg-1 col-sm-6",
          },
          {
            label: "Medio transporte internacional",
            key: "medioTransporteInternacional",
            minWidth: 150,
            maxWidth: 150,
            className: "col-md-3 col-lg-1 col-sm-6",
          },
          {
            label: "Fecha levante",
            key: "fechaLevante",
            minWidth: 150,
            maxWidth: 150,
            className: "col-md-3 col-lg-1 col-sm-6",
          },
          {
            label: "Fecha despacho total",
            key: "fechaDespachoTotal",
            minWidth: 150,
            maxWidth: 150,
            className: "col-md-3 col-lg-1 col-sm-6",
          },
          {
            label: "Anticipo recibido",
            key: "anticipoRecibido",
            minWidth: 150,
            maxWidth: 150,
            className: "col-md-3 col-lg-1 col-sm-6",
          },
          {
            label: "Proforma",
            key: "proforma",
            minWidth: 150,
            maxWidth: 150,
            className: "col-md-3 col-lg-1 col-sm-6",
          },
          {
            label: "Fecha proforma",
            key: "fechaProforma",
            minWidth: 150,
            maxWidth: 150,
            className: "col-md-3 col-lg-1 col-sm-6",
          },
          {
            label: "Valor gastos terceros",
            key: "valorGastosTerceros",
            minWidth: 150,
            maxWidth: 150,
            className: "col-md-3 col-lg-1 col-sm-6",
          },
          {
            label: "Valor ingresos propios",
            key: "valorIngresosPropios",
            minWidth: 150,
            maxWidth: 150,
            className: "col-md-3 col-lg-1 col-sm-6",
          },
          {
            label: "Fecha máxima autorización",
            key: "fechaMaximaAutorizacion",
            minWidth: 150,
            maxWidth: 150,
            className: "col-md-3 col-lg-1 col-sm-6",
            className: "col-md-3 col-lg-2 col-sm-6",
            custom: (value) => {
              return {
                backgroundColor: value.hex,
                content: <span>{value["fechaMaximaAutorizacion"]}</span>,
              };
            },
          },
        ],
        16: [
          {
            label: "DO",
            key: "do",
            minWidth: 150,
            maxWidth: 170,
            limitString: 20,
            className: "col-md-3 col-lg-2 col-sm-6",
            custom: (value) => ({
              content:
                value?.do?.length > 20 ? (
                  <Popup
                    content={value.do}
                    key={value.do}
                    popperModifiers={{
                      preventOverflow: {
                        boundariesElement: "offsetParent",
                      },
                    }}
                    positionFixed={true}
                    position="top center"
                    size="mini"
                    trigger={
                      <Link
                        style={{ color: "#003F70", fontWeight: "bold" }}
                        to={`/custom-detail-view/` + value.id}
                      >
                        {`${value.do.substring(0, 17)}...`}
                      </Link>
                    }
                  />
                ) : (
                  <Link
                    style={{ color: "#003F70", fontWeight: "bold" }}
                    to={`/custom-detail-view/` + value.id}
                  >
                    {value.do}
                  </Link>
                ),
            }),
          },
          {
            label: "Pedido",
            key: "pedido",
            minWidth: 150,
            maxWidth: 170,
            limitString: 20,
            className: "col-md-3 col-lg-2 col-sm-6",
            custom: (value) => ({
              content:
                value?.pedido?.length > 20 ? (
                  <Popup
                    content={value?.pedido}
                    key={value?.pedido}
                    popperModifiers={{
                      preventOverflow: {
                        boundariesElement: "offsetParent",
                      },
                    }}
                    positionFixed={true}
                    position="top center"
                    size="mini"
                    trigger={
                      <span>{`${value?.pedido.substring(0, 17)}...`}</span>
                    }
                  />
                ) : (
                  <span>{value?.pedido}</span>
                ),
            }),
          },
          {
            label: "Serv. al cliente (CS)",
            key: "servCliente",
            minWidth: 150,
            maxWidth: 150,
            className: "col-md-3 col-lg-1 col-sm-6",
          },
          {
            label: "Cliente",
            key: "cliente",
            minWidth: 150,
            maxWidth: 150,
            className: "col-md-3 col-lg-1 col-sm-6",
          },
          {
            label: "Aduana",
            key: "aduana",
            minWidth: 150,
            maxWidth: 150,
            className: "col-md-3 col-lg-1 col-sm-6",
          },
          {
            label: "Medio transporte internacional",
            key: "medioTransporteInternacional",
            minWidth: 150,
            maxWidth: 150,
            className: "col-md-3 col-lg-1 col-sm-6",
          },
          {
            label: "Fecha levante",
            key: "fechaLevante",
            minWidth: 150,
            maxWidth: 150,
            className: "col-md-3 col-lg-1 col-sm-6",
          },
          {
            label: "Fecha despacho total",
            key: "fechaDespachoTotal",
            minWidth: 150,
            maxWidth: 150,
            className: "col-md-3 col-lg-1 col-sm-6",
          },
          {
            label: "Anticipo recibido",
            key: "anticipoRecibido",
            minWidth: 150,
            maxWidth: 150,
            className: "col-md-3 col-lg-1 col-sm-6",
          },
          {
            label: "Factura",
            key: "factura",
            minWidth: 150,
            maxWidth: 150,
            className: "col-md-3 col-lg-1 col-sm-6",
          },
          {
            label: "Fecha factura",
            key: "fechaFactura",
            minWidth: 150,
            maxWidth: 150,
            className: "col-md-3 col-lg-1 col-sm-6",
          },
          {
            label: "Valor gastos terceros",
            key: "valorGastosTerceros",
            minWidth: 150,
            maxWidth: 150,
            className: "col-md-3 col-lg-1 col-sm-6",
          },
          {
            label: "Valor ingresos propios",
            key: "valorIngresosPropios",
            minWidth: 150,
            maxWidth: 150,
            className: "col-md-3 col-lg-1 col-sm-6",
          },
          {
            label: "Días de cartera",
            key: "diasCartera",
            minWidth: 150,
            maxWidth: 150,
            className: "col-md-3 col-lg-1 col-sm-6",
          },
          {
            label: "Fecha máxima de pago",
            key: "fechaMaximaPago",
            minWidth: 150,
            maxWidth: 150,
            className: "col-md-3 col-lg-1 col-sm-6",
            className: "col-md-3 col-lg-2 col-sm-6",
            custom: (value) => {
              return {
                backgroundColor: value.hex,
                content: <span>{value["fechaMaximaPago"]}</span>,
              };
            },
          },
        ],
        17: [
          {
            label: "Cliente",
            key: "cliente",
            minWidth: 150,
            maxWidth: 150,
            className: "col-md-3 col-lg-1 col-sm-6",
          },
          {
            label: "Proveedor",
            key: "proveedor",
            minWidth: 150,
            maxWidth: 150,
            className: "col-md-3 col-lg-1 col-sm-6",
          },
          {
            label: "Número de registro",
            key: "numeroRegistro",
            minWidth: 150,
            maxWidth: 150,
            className: "col-md-3 col-lg-1 col-sm-6",
          },
          {
            label: "Fecha vencimiento registro",
            key: "fechaVencimientoRegistro",
            minWidth: 150,
            maxWidth: 150,
            className: "col-md-3 col-lg-1 col-sm-6",
          },
          {
            label: "Tipo de permiso",
            key: "tipoPermiso",
            minWidth: 150,
            maxWidth: 150,
            className: "col-md-3 col-lg-1 col-sm-6",
          },
          {
            label: "Fecha vencimiento permiso",
            key: "fechaVencimientoPermiso",
            minWidth: 150,
            maxWidth: 150,
            className: "col-md-3 col-lg-1 col-sm-6",
          },
          {
            label: "Días para vencer",
            key: "diasParaVencer",
            minWidth: 150,
            maxWidth: 150,
            className: "col-md-3 col-lg-1 col-sm-6",
          },
          {
            label: "Fecha máxima vigencia",
            key: "fechaMaximaVigencia",
            minWidth: 150,
            maxWidth: 150,
            className: "col-md-3 col-lg-1 col-sm-6",
            className: "col-md-3 col-lg-2 col-sm-6",
            custom: (value) => {
              return {
                backgroundColor: value.hex,
                content: <span>{value["fechaMaximaVigencia"]}</span>,
              };
            },
          },
        ],
      },
      columnsTable: [],
      dataTable: [],
      totalCards: [],
      selectedFilters: {
        Pedido: [],
        OC: [],
        Referencia: [],
        Factura: [],
        "Doc. Trans.": [],
        "País de origen": [],
        DO: [],
        Aduana: [],
      },
      timeLineData: [],
      loadingModal: false,
    };
    this.handleChange = this.handleChange.bind(this);
  }

  /*=============================================
  =            Life Cicle Component             =
  =============================================*/

  componentDidMount = async () => {
    document.getElementById("body").className = "layout-fixed"; // !changed for nothing
    console.log("rolId", this.state.rolId);

    await this.getHomeData();
    //await this.getFilterData();

    this.setState({
      isMovilDevice: isMovil(),
    });
  };

  handleResize = () => {
    this.setState({ customWidth: window.innerWidth });
  };

  componentWillMount() {
    window.addEventListener("resize", this.handleResize);
  }
  componentWillUnmount() {
    window.removeEventListener("resize", this.handleResize);
  }

  handleChange(newValue) {
    this.setState({ value: newValue });
  }

  getTableDetails = async (id, name, page = 1, search = "") => {
    try {
      this.setState(
        {
          columnsTable: [],
          dataTable: [],
          titleModal: name,
          activePage: page,
          dashboardConfigId: id,
          loadingModal: true,
        },
        async () => {
          const columns = this.state.ImpoDetailsTables[id] ?? [];
          // const response = {
          //   data: [
          //     {
          //       dosId: "CTG2503678003",
          //       pedido: "27-2025",
          //       duenoDo: "NICOL AREVALO",
          //       razonSocial: "PERNOD RICARD COLOMBIA S.A.",
          //       aduanaDeclaracion: "CARTAGENA",
          //       viaNombre: "MARÍTIMO",
          //       aerolineaNaviera:
          //         "MAERSK COLOMBIA S.A - TRANSPORTADOR MARITIMO",
          //       nombreProveedor: "SCHNEIDER ELECTRIC IT CORPORATION",
          //       documentoTransporte: "HLCUHAV250200163",
          //       numeroFactura: "FE00008583, FE00008582",
          //       fechaEstimadaArribo: "2025-02-12",
          //       trayecto: "T.CORTO",
          //       "Fecha máxima aceptación": "14/02/2025",
          //       backgroundColor: "#D51C29",
          //     },
          //     {
          //       dosId: "CTG2503678003",
          //       pedido: "27-2025",
          //       duenoDo: "NICOL AREVALO",
          //       razonSocial: "PERNOD RICARD COLOMBIA S.A.",
          //       aduanaDeclaracion: "CARTAGENA",
          //       viaNombre: "MARÍTIMO",
          //       aerolineaNaviera:
          //         "MAERSK COLOMBIA S.A - TRANSPORTADOR MARITIMO",
          //       nombreProveedor: "SCHNEIDER ELECTRIC IT CORPORATION",
          //       documentoTransporte: "HLCUHAV250200163",
          //       numeroFactura: "FE00008583, FE00008582",
          //       fechaEstimadaArribo: "2025-02-12",
          //       trayecto: "T.CORTO",
          //       "Fecha máxima aceptación": "14/02/2025",
          //       backgroundColor: "#FFFF1D",
          //     },
          //     {
          //       dosId: "CTG2503678003",
          //       pedido: "27-2025",
          //       duenoDo: "NICOL AREVALO",
          //       razonSocial: "PERNOD RICARD COLOMBIA S.A.",
          //       aduanaDeclaracion: "CARTAGENA",
          //       viaNombre: "MARÍTIMO",
          //       aerolineaNaviera:
          //         "MAERSK COLOMBIA S.A - TRANSPORTADOR MARITIMO",
          //       nombreProveedor: "SCHNEIDER ELECTRIC IT CORPORATION",
          //       documentoTransporte: "HLCUHAV250200163",
          //       numeroFactura: "FE00008583, FE00008582",
          //       fechaEstimadaArribo: "2025-02-12",
          //       trayecto: "T.CORTO",
          //       "Fecha máxima aceptación": "14/02/2025",
          //       backgroundColor: "#83c93c",
          //     },
          //   ],
          // };
          const url = `${Services.TABLEROS.path}/api/v1/dashboard/getDetails`;
          const auth = localStorage.getItem("token");
          let data = {
            customer: this.props.clients
              ? JSON.stringify(this.props.clients)
              : "[0]",
            appliedFilters: JSON.stringify(this.state.selectedFilters),
            page,
            dashboardConfigId: id,
            search,
          };
          const response = await Axios.post(url, data, {
            headers: {
              authorization: auth,
            },
          });
          this.setState(
            {
              columnsTable: columns,
              dataTable:
                response.data?.data?.spGetImportDashboardDetail?.data ?? [],
              pages: response.data?.data?.spGetImportDashboardDetail
                ?.totalRecords
                ? Math.ceil(
                    parseInt(
                      response.data?.data?.spGetImportDashboardDetail
                        ?.totalRecords,
                    ) / 10,
                  )
                : 1,
            },
            async () => {
              this.setState({ viewDetails: true, loadingModal: false });
            },
          );
        },
      );
    } catch (error) {
      console.log("🚀 ~  ~ error:", error);
      this.setState({
        viewDetails: false,
        loadingModal: false,
      });
    }
  };

  getTableDetailsAll = async (id, search = "") => {
    try {
      const url = `${Services.TABLEROS.path}/api/v1/dashboard/getDetailsAll`;
      const auth = localStorage.getItem("token");
      let data = {
        customer: this.props.clients
          ? JSON.stringify(this.props.clients)
          : "[0]",
        appliedFilters: JSON.stringify(this.state.selectedFilters),
        dashboardConfigId: id,
        search,
      };
      const response = await Axios.post(url, data, {
        headers: {
          authorization: auth,
        },
      });
      return response.data?.data?.spGetImportDashboardDetail?.data;
    } catch (error) {
      console.log("🚀 ~  ~ error:", error);
      this.setState({
        viewDetails: false,
      });
    }
  };

  handleClickDetails = (text, name) => {
    if (this.state.loadingDetails) return; // Evita doble clic
    this.setState({ loadingDetails: true });
    this.getTableDetails(text, name).finally(() => {
      this.setState({ loadingDetails: false }); // Quita esto si quieres que quede bloqueado
    });
  };

  handleSearch = (event) =>
    this.setState({ searchInput: event.target.value });
  setSearch = () => {
    const { searchInput, titleModal, dashboardConfigId } = this.state;
    this.setState({ search: searchInput }, () => {
      this.getTableDetails(dashboardConfigId, titleModal, 1, searchInput).finally(
        () => {
          this.setState({ loadingDetails: false });
        },
      );
    });
  };

  getHomeData = async () => {
    try {
      this.setState(
        {
          totalCards: [],
          fullLoader: false,
          timeLineData: [],
        },
        async () => {
          const url = `${Services.TABLEROS.path}/api/v1/dashboard/getTotal`;
          const auth = localStorage.getItem("token");
          let data = {
            customer: this.props.clients
              ? JSON.stringify(this.props.clients)
              : "[0]",
          };
          const response = await Axios.post(url, data, {
            headers: {
              authorization: auth,
            },
          });

          // const response = {
          //   data: {
          //     totals: [
          //       {
          //         icon: "https://fsposeidon.blob.core.windows.net/roldan/icon_landTracking@16x.svg",
          //         name: "Estado tránsito intern (aplica con ser. de tracking)",
          //         value: 15,
          //       },
          //       {
          //         icon: "https://fsposeidon.blob.core.windows.net/roldan/icon_warehouse@16x.svg",
          //         name: "Llegado",
          //         value: 234,
          //       },
          //       {
          //         icon: "https://fsposeidon.blob.core.windows.net/roldan/icon_warehouseVisibility@16x.svg",
          //         name: "Insp. prev.  o sanitarias",
          //         value: 45,
          //       },
          //       {
          //         icon: "https://fsposeidon.blob.core.windows.net/roldan/icon_certificateCheck@16x.svg",
          //         name: "Aceptados",
          //         value: 189,
          //       },
          //       {
          //         icon: "https://fsposeidon.blob.core.windows.net/roldan/icon_warehouseSavings@16x.svg",
          //         name: "Para pago",
          //         value: 23,
          //       },
          //       {
          //         icon: "https://fsposeidon.blob.core.windows.net/roldan/icon_warehouseVisibility@16x.svg",
          //         name: "Insp.  DIAN",
          //         value: 166,
          //       },
          //       {
          //         icon: "https://fsposeidon.blob.core.windows.net/roldan/icon_scheduleImports@16x.svg",
          //         name: "Levante sin entrega trans.",
          //         value: 12,
          //       },
          //       {
          //         icon: "https://fsposeidon.blob.core.windows.net/roldan/icon_documentDownload@16x.svg",
          //         name: "Sin facturar",
          //         value: 34,
          //       },
          //       {
          //         icon: "https://fsposeidon.blob.core.windows.net/roldan/icon_landFreight@16x.svg",
          //         name: "En tránsito NNAL o con sello RIS",
          //         value: 28,
          //       },
          //     ],
          //     dataTables: [
          //       {
          //         items: [
          //           {
          //             Id: 1,
          //             Name: "Embarques con DIM anticipadas SIN aceptar",
          //             Total: 0,
          //             EnRiesgo: 0,
          //             TipoDias: "Días calendario",
          //             Desviados: 0,
          //           },
          //           {
          //             Id: 2,
          //             Name: "Embarques como entrega directa llegados SIN levante",
          //             Total: 0,
          //             EnRiesgo: 0,
          //             TipoDias: "Días hàbiles",
          //             Desviados: 0,
          //           },
          //           {
          //             Id: 4,
          //             Name: "DO's con DIM aceptadas SIN autoadhesivo o pago",
          //             Total: 0,
          //             EnRiesgo: 0,
          //             TipoDias: "Días hàbiles",
          //             Desviados: 0,
          //           },
          //           {
          //             Id: 3,
          //             Name: "Mercancia en deposito público SIN levante",
          //             Total: 0,
          //             EnRiesgo: 0,
          //             TipoDias: "Días calendario",
          //             Desviados: 0,
          //           },
          //           {
          //             Id: 5,
          //             Name: "Operaciones de DTA",
          //             Total: 0,
          //             EnRiesgo: 0,
          //             TipoDias: "Días hàbiles",
          //             Desviados: 0,
          //           },
          //         ],
          //         groupName: "EN PROCESO DE ADUANA",
          //       },
          //     ],
          //   },
          // };
          const totalCards =
            response?.data?.data?.spGetImportDashboard?.totals.map((t) => {
              return (
                <CardsTotals
                  image={t.icon}
                  xl={3}
                  md={3}
                  total={t.value}
                  title={t.name}
                  propertiesIcon={
                    "col-4 d-flex align-items-center bgg-gray-dark justify-content-center rounded-left"
                  }
                  propertiesTitle={
                    "d-flex col-8 py-3 bgg-gray align-items-center justify-content-center rounded-right"
                  }
                />
              );
            });

          const table =
            response?.data?.data?.spGetImportDashboard?.dataTables?.find(
              (table) => table.groupName === "EN PROCESO DE ADUANA",
            );

          if (table) {
            this.setState({ processData: table.items });
          }

          const tablePending =
            response?.data?.data?.spGetImportDashboard?.dataTables?.find(
              (table) => table.groupName === "CON PENDIENTES",
            );

          if (tablePending) {
            this.setState({ pendingData: tablePending.items });
          }

          const tableBilling =
            response?.data?.data?.spGetImportDashboard?.dataTables?.find(
              (table) => table.groupName === "ANTICIPO, FACTURACION Y CARTERA",
            );

          if (tableBilling) {
            this.setState({ billingData: tableBilling.items });
          }

          const tableDocuments =
            response?.data?.data?.spGetImportDashboard?.dataTables?.find(
              (table) => table.groupName === "CONTROL VIGENCIAS DE DOCUMENTOS",
            );

          if (tableDocuments) {
            this.setState({ documentsData: tableDocuments.items });
          }

          const timeLineData =
            response?.data?.data?.spGetImportDashboard?.totals ?? [];

          this.setState({ totalCards: totalCards, timeLineData }, async () => {
            this.setState({ fullLoader: true });
          });
        },
      );
    } catch (error) {
      console.log("🚀 ~  ~ error:", error);
      this.setState({ fullLoader: true });
    }
  };

  getHomeDataFilter = async () => {
    try {
      this.setState(
        {
          totalCards: [],
          fullLoader: false,
          timeLineData: [],
        },
        async () => {
          const url = `${Services.TABLEROS.path}/api/v1/dashboard/getTotalFilters`;
          const auth = localStorage.getItem("token");
          let data = {
            customer: this.props.clients
              ? JSON.stringify(this.props.clients)
              : "[0]",
            appliedFilters: JSON.stringify(this.state.selectedFilters),
          };
          const response = await Axios.post(url, data, {
            headers: {
              authorization: auth,
            },
          });

          const totalCards =
            response?.data?.data?.spGetImportDashboard?.totals.map((t) => {
              return (
                <CardsTotals
                  image={t.icon}
                  xl={12}
                  md={12}
                  total={t.value}
                  title={t.name}
                  propertiesIcon={
                    "col-4 d-flex align-items-center bgg-gray-dark justify-content-center rounded-left"
                  }
                  propertiesTitle={
                    "d-flex col-8 py-3 bgg-gray align-items-center justify-content-center rounded-right"
                  }
                />
              );
            });

          const table =
            response?.data?.data?.spGetImportDashboard?.dataTables?.find(
              (table) => table.groupName === "EN PROCESO DE ADUANA",
            );

          if (table) {
            this.setState({ processData: table.items });
          }

          const tablePending =
            response?.data?.data?.spGetImportDashboard?.dataTables?.find(
              (table) => table.groupName === "CON PENDIENTES",
            );

          if (tablePending) {
            this.setState({ pendingData: tablePending.items });
          }

          const tableBilling =
            response?.data?.data?.spGetImportDashboard?.dataTables?.find(
              (table) => table.groupName === "ANTICIPO, FACTURACION Y CARTERA",
            );

          if (tableBilling) {
            this.setState({ billingData: tableBilling.items });
          }

          const tableDocuments =
            response?.data?.data?.spGetImportDashboard?.dataTables?.find(
              (table) => table.groupName === "CONTROL VIGENCIAS DE DOCUMENTOS",
            );

          if (tableDocuments) {
            this.setState({ documentsData: tableDocuments.items });
          }
          const timeLineData =
            response?.data?.data?.spGetImportDashboard?.totals ?? [];
          this.setState({ totalCards: totalCards, timeLineData }, async () => {
            this.setState({ fullLoader: true });
          });
        },
      );
    } catch (error) {
      console.log("🚀 ~  ~ error:", error);
      this.setState({ fullLoader: true });
    }
  };

  getFilterData = async (search, prevOptions) => {
    this.setState(
      {
        loadingTrends: !this.stateloadingTrends,
      },
      async () => {
        try {
          const dicSelect = {
            Pedido: "pedido",
            OC: "oc",
            Referencia: "referencia",
            Factura: "factura",
            "Doc. Trans.": "docTrans",
            "País de origen": "paisOrigen",
            DO: "do",
            Aduana: "aduana",
          };
          const url = `${Services.TABLEROS.path}/api/v1/dashboard/getFilters`;
          const auth = localStorage.getItem("token");
          let data = {
            customer: this.props.clients
              ? JSON.stringify(this.props.clients)
              : "[0]",
            search,
            page: 1,
            filter: "pedido",
          };
          const response = await Axios.post(url, data, {
            headers: {
              authorization: auth,
            },
          });

          const dataFilters = response?.data?.data;

          return;
        } catch (error) {
          console.log("🚀 ~  ~ error:", error);
          this.setState({ fullLoader: true });
        }
      },
    );
  };

  setValueFilters = async (filter, data) => {
    let selectedFilters = this.state.selectedFilters;
    selectedFilters[filter] = [...data];
    this.setState({ selectedFilters }, async () => {
      await this.getHomeDataFilter();
    });
  };

  changePage = async (changePage) => {
    const { titleModal, dashboardConfigId, search } = this.state;
    this.getTableDetails(
      dashboardConfigId,
      titleModal,
      changePage,
      search,
    ).finally(() => {
      this.setState({ loadingDetails: false });
    });
  };

  // downloadExcel = async () => {
  //   this.setState({
  //     loading: true,
  //   });
  //   let dateNow = new Date();
  //   let titleDownload = `Facturacion${
  //     dateNow.getDate() +
  //     "" +
  //     (dateNow.getMonth() + 1) +
  //     "" +
  //     dateNow.getFullYear()
  //   }`;

  //   let {
  //     numberPageInvoice,
  //     limitInvoice,
  //     searchInvoice,
  //     clientesSelect,
  //     filters,
  //     search,
  //   } = this.state;

  //   let data = {
  //     client: clientesSelect,
  //     pag: numberPageInvoice,
  //     limit: limitInvoice,
  //     search: searchInvoice,
  //     allData: true,
  //     search: search,
  //   };

  //   axios
  //     .post(
  //       `${Services.Api_Costos.path}/invoicing/downloadgetdataall?${filters}`,
  //       data
  //     )
  //     .then((success) => {
  //       const fileName = titleDownload + ".xlsx";
  //       const linkSource = `data:application/xlsx;base64,${success.data.dataReport}`;
  //       saveAs(linkSource, fileName);
  //       this.setState({
  //         loading: false,
  //       });
  //     })
  //     .catch((error) => {
  //       // this.setState({ loading: false });
  //     });
  // };

  generateExcel = async () => {
    this.setState({ loading: true });
    if (!(this.state.dataTable.length > 0)) {
      this.setState({
        loading: false,
      });
      return;
    }
    let search = this.state.search;
    const { dashboardConfigId } = this.state;
    let keys = [];
    let headers = [];
    const columnsData = this.state.ImpoDetailsTables[dashboardConfigId];

    columnsData.forEach((data) => {
      keys.push(data.key);
      headers.push(data.label);
    });

    let alldata = await this.getTableDetailsAll(dashboardConfigId, search);
    const columColor = keys[keys.length - 1];
    const dataxls = {
      data: alldata,
      options: {
        keys,
        headers,
        image: {
          name: "roldan",
        },
        sheetName: `${this.state.titleModal}_${moment(new Date()).format(
          "YYYYMMDD",
        )}`,
        columnStyles: {
          [columColor]: {
            fromField: "hex",
          },
        },
      },
    };

    try {
      if (alldata.length !== 0) {
        const getXlsxFile = await Axios.post(
          `${Services.DOWNLOAD_FILES.path}/report/dynamic/xlsx`,
          dataxls,
        );
        const fileName = `${this.state.titleModal}_${moment(new Date()).format(
          "YYYYMMDD",
        )}.xlsx`;
        const linkSource =
          "data:application/xlsx;base64," + getXlsxFile.data.base64;
        saveAs(linkSource, fileName);
        this.setState({
          loading: false,
        });
      } else {
        this.setState({
          loading: false,
        });
      }
    } catch (error) {
      console.log("🚀 ~ generateExcel= ~ error:", error);
      this.setState({
        loading: true,
      });
    }
  };

  /*=============================================
  =            Render Method                    =
  =============================================*/

  render() {
    const {
      fullLoader,
      filters,
      loadingTrends,
      processData,
      pendingData,
      billingData,
      documentsData,
      titleModal,
      columnsTable,
      dataTable,
      viewDetails,
      pages,
      searchInput,
      loading,
      totalCards,
      activePage,
      timeLineData,
      loadingModal,
    } = this.state;
    return (
      <>
        {/* <Loader hidden={fullLoader}/> */}
        <>
          <Loader hidden={fullLoader} />
          <ContentWrapper>
            <div className="content-heading">
              <legend className="legendTitle">
                <img
                  // style={{ margin: "6px", marginTop: "-1px" }}
                  src="https://fsposeidon.blob.core.windows.net/roldan/icon_containerVisibility@16x.svg"
                  height="28"
                  width="28"
                ></img>
                Tablero aduana importaciones
              </legend>
            </div>
            {loadingModal ? (
              <center>
                {" "}
                <Loader />
              </center>
            ) : (
              <Modal
                title={
                  <h4
                    style={{
                      fontSize: "20px",
                      padding: "0.5rem",
                      color: "#fff",
                    }}
                  >
                    {titleModal}
                  </h4>
                }
                centered
                open={viewDetails}
                footer={[]}
                onOk={() =>
                  this.setState({
                    viewDetails: false,
                    search: '',
                    searchInput: '',
                  })
                }
                onCancel={() =>
                  this.setState({
                    viewDetails: false,
                    search: '',
                    searchInput: '',
                  })
                }
                width={2000}
              >
                <div style={{ padding: "1.5rem" }}>
                  <div className="row">
                    <div className="col-xs-12 col-md-6 col-lg-6 row pb-3">
                      <div className="col-10">
                        <Search
                          input={{
                            icon: "search",
                            iconPosition: "left",
                            fluid: true,
                          }}
                          placeholder="..."
                          value={searchInput}
                          open={false}
                          name="search"
                          id="search"
                          onSearchChange={this.handleSearch}
                          onKeyDown={(e) => {
                            if (e.key === "Enter") {
                              this.setSearch();
                            }
                          }}
                        />
                      </div>
                      <div className="col-2 visible-xls-desktops">
                        {loading ? (
                          <center>
                            {" "}
                            <Icon
                              loading={loading}
                              style={{ marginTop: "3px", marginLeft: "-3em" }}
                              name="circle notch"
                              size="large"
                            />
                          </center>
                        ) : (
                          <center>
                            <em
                              style={{
                                color: "#43a047",
                                marginTop: "4px",
                                marginLeft: "-3em",
                              }}
                              onClick={this.generateExcel}
                              className="download fa-2x fas fa-file-excel"
                            ></em>
                          </center>
                        )}
                      </div>
                    </div>
                  </div>
                  <DataTable
                    data={dataTable}
                    columnsTable={columnsTable}
                    subTable={[]}
                    activePage={activePage}
                    numberPageInvoice={pages}
                    handlePaginationChange={this.changePage}
                  ></DataTable>
                </div>
              </Modal>
            )}
            {/* <Card> */}
            <div className="row">
              {filters.map((f) => {
                return (
                  <div className={f.col}>
                    <MultiSelectPaginate
                      loadOptions={getFilterData}
                      title={f.title}
                      clients={
                        this.props.clients
                          ? JSON.stringify(this.props.clients)
                          : "[0]"
                      }
                      setValueFilters={this.setValueFilters}
                    />
                  </div>
                );
              })}
            </div>
            <Divider />
            {/* <div className="wraped_totals_tablero">
              {totalCards.map((card) => {
                return card;
              })}
            </div> */}
            <Row>
              {/*totalCards.map((card) => {
                return card;
              })*/}
              {loadingTrends ? (
                <FullLoader />
              ) : (
                <HorizontalTimeline data={timeLineData} />
              )}
            </Row>
            <Divider />
            <Row>
              <Col xs={12} md={12} lg={6}>
                <div className="card myCard equalsWidth">
                  <div className="card-header">
                    <div className="card-title-board">
                      {" "}
                      En proceso de aduana{" "}
                    </div>
                  </div>
                  <div
                    style={{ fontWeight: 100, marginTop: "-2rem" }}
                    className="card-body"
                  >
                    {loadingTrends ? (
                      <FullLoader />
                    ) : (
                      <div>
                        <Table
                          data={processData}
                          columns={this.state.columnsProcess}
                          options={{
                            pagination: false,
                            search: false,
                            downloads: { xlsx: false, pdf: false },
                          }}
                        ></Table>
                      </div>
                    )}
                  </div>
                </div>
              </Col>
              <Col xs={12} md={12} lg={6}>
                <div className="card myCard equalsWidth">
                  <div className="card-header">
                    <div className="card-title-board"> Con pendientes </div>
                  </div>
                  <div
                    style={{ fontWeight: 100, marginTop: "-2rem" }}
                    className="card-body"
                  >
                    {loadingTrends ? (
                      <FullLoader />
                    ) : (
                      <div>
                        <Table
                          data={pendingData}
                          columns={this.state.columnsProcess}
                          options={{
                            pagination: false,
                            search: false,
                            downloads: { xlsx: false, pdf: false },
                          }}
                        ></Table>
                      </div>
                    )}
                  </div>
                </div>
              </Col>
              <Col xs={12} md={12} lg={6}>
                <div className="card myCard equalsWidth">
                  <div className="card-header">
                    <div className="card-title-board">
                      {" "}
                      Anticipos, Facturación y Cartera{" "}
                    </div>
                  </div>
                  <div
                    style={{ fontWeight: 100, marginTop: "-2rem" }}
                    className="card-body"
                  >
                    {loadingTrends ? (
                      <FullLoader />
                    ) : (
                      <div>
                        <Table
                          data={billingData}
                          columns={this.state.columnsProcess}
                          options={{
                            pagination: false,
                            search: false,
                            downloads: { xlsx: false, pdf: false },
                          }}
                        ></Table>
                      </div>
                    )}
                  </div>
                </div>
              </Col>
              {/* <Col xs={12} md={12} lg={6}>
                <div className="card myCard equalsWidth">
                  <div className="card-header">
                    <div className="card-title-board">
                      {" "}
                      Control vigencia de documentos{" "}
                    </div>
                  </div>
                  <div
                    style={{ fontWeight: 100, marginTop: "-2rem" }}
                    className="card-body"
                  >
                    {loadingTrends ? (
                      <FullLoader />
                    ) : (
                      <div>
                        <Table
                          data={documentsData}
                          columns={this.state.columnsProcess}
                          options={{
                            pagination: false,
                            search: false,
                            downloads: { xlsx: false, pdf: false },
                          }}
                        ></Table>
                      </div>
                    )}
                  </div>
                </div>
              </Col> */}
            </Row>
          </ContentWrapper>
        </>
      </>
    );
  }
}
const mapStateToProps = (state) => ({
  clients: state.header.clients,
});
const mapDispatchToProps = () => ({});

export default connect(mapStateToProps, mapDispatchToProps)(BoardImpo);
